import React, { MouseEvent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { DateBox, TextBox, NumberBox, LoadPanel, TextArea, SelectBox, Popup, ScrollView } from "devextreme-react";
import DropDownFromLookupTableDynamic from "../select/SelectBoxFromLookupTableDynamic";
import DropDownFromLookupTable from "../select/SelectBoxFromLookupTable";
import {
    DateBoxOnValueChangedEvent,
    LookUpOnValueChangedEvent,
    NumberBoxOnValueChangedEvent,
    SelectBoxOnValueChangedEvent,
    TextBoxOnValueChangedEvent,
} from "../../types/DevExtremeTypes";
import LookupService, { LookupTypeIndexes, LookupTypeItem, UnitOfMeasureTypes } from "../../services/LookupService";
import { AxiosResponse } from "axios";
import LightModePageTemplate from "../page/Templates/LightModeTemplate";
import SideBarTemplate from "../side-bar/SideBarTemplate";
import BulletinPanel from "../BulletinPanel/BulletinPanel";
import LookupTypeListDynamic from "../select/LookupTypeListDynamic";
import QuickAddShiftUtils, { QuickShiftFormData } from "./QuickAddShiftUtils";
import { ServiceType, SubServiceType, ChargingType } from "../../common/ServiceUtilities";
import { serviceTypes } from "../../services/FileService";
import outstandingActionsUtilities, { minuteLookup } from "../Outstanding-Actions/OutstandingActionsUtilities";
import AddEditPopUpService, { QuickBillableItemSubmitRequest, Status, CalculationResponse } from "../../services/AddEditPopUpService";
import ServiceFeeService from "../../services/ServiceFeesService";
import addEditPopupUtils, { BusinessEntityTaxApplicableStatus, BusinessEntityTypes, itemTypes } from "../grid/AddEditPopUpUtilities";
import billableItemUtils from "../Utility/billableItemUtils";
import sharedUtils from "../grid/sharedUtilities";
import FindAnArtistUtils from "../FindAnArtist/FindAnArtistUtils";
import AddEditFormV2 from "../grid/AddEditFormV2";
import moment from "moment";
import UserService, { RoleGroupNames } from "../../services/UserService";
import { resolveGuardedDependentId } from "../../common/featureFlags";

interface QuickAddShiftFormProps extends WithTranslation {
    location: any;
    history: any;
    billableItemId?: string;
    navigateFrom?: string;
    hidePopup: (
        isPopupVisible: boolean
    ) => void;
    date?: Date|null;
    venueId?: string;
    serviceTypeId?:string;
    clientId?:string;
    providerId?:string;
    hideAndRefresh?:()=>void
}

interface QuickAddShiftFormState {
    loadPanelVisible: boolean;
    quickShiftFormData: QuickShiftFormData;
    businessEntityTaxApplicableStatuses: BusinessEntityTaxApplicableStatus[];
    errorMessage: any;
    confirmationPanelVisible: boolean;
    errorPanelVisible: boolean;
    createNewRequestButtonVisible: boolean;
    hours: number|undefined;
    minutes: string;
    hourChangeTimer: any;
    unitOfMeasureList: LookupTypeItem[];
    CleaningMinutesToDisplay: string;
    typeLookUp: LookupTypeItem[];
    offeringsTypeLookup: LookupTypeItem[];
    showWarningPopup: boolean;
    showCalculatedPopup: boolean;
    isPopupProviderNetChange: boolean;
    isPopupEventNetChange: boolean;
    isRequestCalculationChange: boolean;
    profileLookup:LookupTypeItem[];
    previouslySourced:boolean;
    existingAct:boolean;
    sourceIntroAllowed:boolean
    isClientSelected: boolean;
}

// Product Backlog Item 16295: Quick Add Shift - Pop-Up - UI and Testing
class QuickAddShiftForm extends React.Component<QuickAddShiftFormProps> {
    utils: QuickAddShiftUtils;
    findAnArtistUtils: FindAnArtistUtils;
    outStandingActionUtils: outstandingActionsUtilities;
    addEditutils: addEditPopupUtils;
    billableItemUtils: billableItemUtils;
    state: QuickAddShiftFormState;
    sharedUtils: sharedUtils;
    service: AddEditPopUpService;
    serviceFeeService: ServiceFeeService;
    lookupService: LookupService;
    updateCorrectionDataSource: LookupTypeItem[];
    submitRecord: string;
    constructor(props: QuickAddShiftFormProps) {
        super(props);
        this.submitRecord = "";
        this.utils = new QuickAddShiftUtils();
        this.sharedUtils = new sharedUtils();
        this.service = new AddEditPopUpService();
        this.serviceFeeService = new ServiceFeeService();
        this.lookupService = new LookupService();
        this.addEditutils = new addEditPopupUtils();
        this.billableItemUtils = new billableItemUtils();
        this.findAnArtistUtils = new FindAnArtistUtils();
        this.outStandingActionUtils = new outstandingActionsUtilities();
        this.updateCorrectionDataSource = this.lookupService.getUpdateOrCorrection();
        // Initialize state
        let itemId: string = "";
        if (props.location && props.location.state && props.location.state.id) {
            itemId = props.location.state.id.toString();
        }
        let convertedQuickShiftFormData = this.utils.initializeQuickShiftItems(itemId);
        // Initialize state
        this.state = {
            loadPanelVisible: false,
            quickShiftFormData: convertedQuickShiftFormData,
            errorMessage: [],
            confirmationPanelVisible: false,
            errorPanelVisible: false,
            createNewRequestButtonVisible: false,
            hours: undefined,
            minutes: "",
            hourChangeTimer: null,
            unitOfMeasureList: [],
            businessEntityTaxApplicableStatuses: [],
            CleaningMinutesToDisplay: "",
            typeLookUp: [],
            offeringsTypeLookup: [],
            showWarningPopup: false,
            showCalculatedPopup: false,
            isPopupProviderNetChange: false,
            isPopupEventNetChange: false,
            isRequestCalculationChange: false,
            profileLookup:[],
            previouslySourced:false,
            existingAct:false,
            sourceIntroAllowed:false,
            isClientSelected: false,
        };
    }

    componentDidMount(): void {
        this.lookupService
            .getLookupByLookupTypeIndex(LookupTypeIndexes.unitOfMeasure)
            .then(this.handleUnitOfMeasureLookupSuccess)
            .catch();
        this.service
            .getTaxApplicableStatus()
            .then(this.handleTaxApplicableSuccess)
            .catch();
        if (this.props.location.state?.id) {
            this.service
                .getEditViewData(parseInt(this.props.location.state.id))
                .then(this.handleSuccessViewDataSource)
                .catch();
        }
        else if(this.props.billableItemId){
            this.service
                .getEditViewData(parseInt(this.props.billableItemId))
                .then(this.handleSuccessViewDataSource)
                .catch();
        }
        else {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    billableStatusLookupId: Status.Pending,
                    itemTypeId: itemTypes.Original,
                    billableItemId: "0"
                }
            }));
        }
        if(this.props.navigateFrom === "venueCalendar"){
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                ...prevState.quickShiftFormData,
                billableStatusLookupId: Status.Pending,
                clientId: this.props.clientId,
                venueId:this.props.venueId,
                serviceTypeId:this.props.serviceTypeId,
                date:this.props.date,
                itemTypeId: itemTypes.Original
            },
            isRequestCalculationChange: true,
            }), () => { this.offeringsTypeDataSource(this.props.serviceTypeId?this.props.serviceTypeId:"") });
        } 
        if(this.props.navigateFrom === "providerCalendar"){
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                ...prevState.quickShiftFormData,
                billableStatusLookupId: Status.Pending,
                serviceTypeId:this.props.serviceTypeId,
                date:this.props.date,
                itemTypeId: itemTypes.Original,
                providerId:this.props.providerId
            },
            isRequestCalculationChange: true,
            }), () => { this.offeringsTypeDataSource(this.props.serviceTypeId?this.props.serviceTypeId:"") });
        } 
    }

    componentDidUpdate(prevProps: Readonly<QuickAddShiftFormProps>): void {
        if (this.props.billableItemId && this.props.billableItemId != prevProps.billableItemId) {
            this.service
                .getEditViewData(parseInt(this.props.billableItemId))
                .then(this.handleSuccessViewDataSource)
                .catch();
        }
    }

    offeringsTypeDataSource = (serviceTypeId: string) => {
        //retrieve the role list 
        if (serviceTypeId == ServiceType.Entertainment || serviceTypeId == ServiceType.ContractCleaning 
            || serviceTypeId == ServiceType.Gardening || serviceTypeId == ServiceType.WindowCleaning) {
            this.lookupService
                .getLookupByLookupTypeIndex(LookupTypeIndexes.offeringsType)
                .then(this.handleSuccesOfferingsLookUp)
                .catch(() => { });
        }
    }

    handleSuccesOfferingsLookUp = (response: AxiosResponse<any>) => {
        let typeDropDown = this.findAnArtistUtils.lookUpCreation(response);
        this.setState({
            typeLookUp: typeDropDown,
        }, () => { this.filterDataSourceForRole(typeDropDown, this.state.quickShiftFormData.serviceSubTypeId); });
    }

    filterDataSourceForRole = (data: LookupTypeItem[], filterId: string) => {
        let mappingId: number = this.sharedUtils.convertStringToInt(filterId);
        let roleTypeItems = mappingId > 0
            ? data.filter((item: LookupTypeItem) => {
                return item.parentMappingId === filterId;
            })
            : data;

        this.setState({
            offeringsTypeLookup: roleTypeItems
        });

    };

    handleUnitOfMeasureLookupSuccess = (response: AxiosResponse<any>) => {
        this.setState({
            unitOfMeasureList: response.data.data,
        });

        this.initializeFieldsBasedOnUnitOfMeasure(
            this.state.quickShiftFormData.serviceSubTypeId,
            response.data.data
        );
    };

    /**
     * Handle the success response for retrieving Tax Applicable statuses
     *
     * @param response {AxiosResponse<any>} - server response
     */
    handleTaxApplicableSuccess = (response: AxiosResponse<any>) => {
        this.setState(
            {
                businessEntityTaxApplicableStatuses: response.data.data,
            },
            // Run after the statuses have committed to state
            this.setFeeTaxApplicableOnInitialLoad
        );
    };

    setFeeTaxApplicableOnInitialLoad = () => {
        let taxApplicable: string = "No";
        let statuses: BusinessEntityTaxApplicableStatus[] = this.state.businessEntityTaxApplicableStatuses;
        // Set the Fee tax applicable field immediately
        let businessEntityItem = statuses.find(
            (item) => item.businessEntityType === BusinessEntityTypes.Company
        );
        if (businessEntityItem && businessEntityItem.taxApplicable) {
            taxApplicable = "Yes";
        }
        if (businessEntityItem) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    fee_Tax_Applicable: taxApplicable,
                },
            }));
        }
    }

    initializeFieldsBasedOnUnitOfMeasure = (subTypeId: string, unitOfMeasureList: LookupTypeItem[]) => {
        // Disabling fields dependent on: 1) the form data server request 2) the unit of measure list
        // Both success promises (this is one) will need to set execute the disable as it cannot be known who's promise will complete first
        if (subTypeId && subTypeId.length > 0) {
            this.lookupService.isSubTypeIdEqualToUnitOfMeasureType(
                subTypeId,
                UnitOfMeasureTypes.time,
                unitOfMeasureList
            )
                ? this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.time)
                : this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.quantity);
        }
    };

    // change for PBI-18255 start
    setUpdateOrCorrectionConditionally = (isAccrual:boolean, invoiceId:string, paymentId:string) => {    
        if(isAccrual == true && invoiceId !== "" && paymentId == ""){
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    updateOrCorrection: "true",
                },
            }))
        }         
    }
    // change for PBI-18255 end

    handleSuccessViewDataSource = (response: AxiosResponse<any>) => {
        // Convert to proper data types
        let viewDataSource = this.utils.convertQuickShiftResponeToFormData(response.data.data);
        this.setState({
            quickShiftFormData: viewDataSource,
            CleaningMinutesToDisplay: response.data.data.equipmentQuantity
        }, () => { this.setUpdateOrCorrectionConditionally(this.state.quickShiftFormData.isAccrual, this.state.quickShiftFormData.invoiceId, this.state.quickShiftFormData.paymentId) });
        this.offeringsTypeDataSource(viewDataSource.serviceTypeId);
        if (viewDataSource.serviceSubTypeId == SubServiceType.WeeklyCleaning) {
            let quantitySubFields: string[] = this.outStandingActionUtils.splitQuantityIntoHoursMinutesFormat(
                response.data.data.equipmentQuantity
            );
            this.setState({
                hours:
                    quantitySubFields.length > 0 && quantitySubFields[0]
                        ? this.sharedUtils.convertStringToInt(quantitySubFields[0])
                        : 0,
                minutes: quantitySubFields.length > 0 && quantitySubFields[1] ? quantitySubFields[1] : "00"
            });
        }
    }

    handleChangeVenueTypeSelect = (dxValueChange: LookUpOnValueChangedEvent) => {
        this.setState((prevState: any) => ({
            quickShiftFormData: {
                ...prevState.quickShiftFormData,
                venueId: dxValueChange.value,
                chargingTypeId: "",
            },
            previouslySourced: false,
            existingAct: false,
        }), () => {
            this.handleMultiplierValueSelection();
        });
    };

    handleChangeProviderTypeSelect = (dxValueChange: LookUpOnValueChangedEvent) => {
        this.setState((prevState: any) => ({
            quickShiftFormData: {
                ...prevState.quickShiftFormData,
                providerId: dxValueChange.value,
                chargingTypeId: "",
            },
            previouslySourced: false,
            existingAct: false,
        }),()=>{
            this.service.getBusinessEntityIds(dxValueChange.value).then(this.handlePaymentCheckSuccessBusinessEntIds)
            .catch((err) => {
                this.setState({
                    errorMessage:
                        err.response && err.response.data && err.response.data.error
                            ? JSON.parse(JSON.stringify(err.response.data.error))
                            : null,
                    IsShowSuccess: false,
                });
                this.failureMessageVisible();
            });
            this.handleMultiplierValueSelection();
        });
        this.setFeeTaxApplicableOnInitialLoad();
        this.setTaxApplicableStatus(dxValueChange.value);
    }
    handlePaymentCheckSuccessBusinessEntIds = (response: AxiosResponse<any>) => {
        if(response.data.data.length > 0){
            const result = response.data.data.map((item: { profileId: any; professionalName: any; businessEntityId: any; }) => ({
            id: item.profileId,
            value: `${item.professionalName} (${item.profileId})`,
            parentMappingId: ""
            }));
            this.setState({profileLookup:result})
        }else{
            this.setState({profileLookup:[]})
        }
    }
    handleChangeProfileSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
            if (dxValueChange.event !== undefined) {
                this.setState((prevState: any) => ({
                        quickShiftFormData: {
                            ...prevState.quickShiftFormData,
                            providerBusinessEntityProfileId: dxValueChange.value,
                        },
                    }),
                );
            }
        };
    handleChangeServiceTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if(dxValueChange.event !== undefined){
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    serviceTypeId: dxValueChange.value,
                    serviceSubTypeId: "",
                    chargingTypeId: "",
                },
                previouslySourced: false,
                existingAct: false,
                isRequestCalculationChange: true,
            }), () => {
                this.offeringsTypeDataSource(dxValueChange.value);
                this.setQuantityAutomaticallyBasedOnService();
                this.handleMultiplierValueSelection();
                this.selectHardApprovalHoldPaymentValue();
            });
            // if (dxValueChange.value == ServiceType.Entertainment) {
            //     this.setState((prevState: any) => ({
            //         quickShiftFormData: {
            //             ...prevState.quickShiftFormData,
            //             equipmentScheduleQuantity: 1,
            //         },
            //         isRequestCalculationChange: true,
            //     }));
            // }
        } else {
            this.handleMultiplierValueSelection();
            this.selectHardApprovalHoldPaymentValue();
        }

    }

    selectHardApprovalHoldPaymentValue = () => {
        // if (this.state.quickShiftFormData.serviceTypeId == ServiceType.Entertainment) {
        //     this.setState((prevState: any) => ({
        //         quickShiftFormData: {
        //             ...prevState.quickShiftFormData,
        //             hardApproval: "No",
        //             holdPayment: "Yes"
        //         },
        //     }));            
        // }
        // else 
        if (this.state.quickShiftFormData.serviceTypeId == ServiceType.ContractCleaning || this.state.quickShiftFormData.serviceTypeId == ServiceType.Entertainment ||
                this.state.quickShiftFormData.serviceTypeId == ServiceType.Miscelleanous || this.state.quickShiftFormData.serviceTypeId == ServiceType.Maintenance || 
                this.state.quickShiftFormData.serviceTypeId == ServiceType.WindowCleaning || this.state.quickShiftFormData.serviceTypeId == ServiceType.Gardening) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    hardApproval: "No",
                    holdPayment: "Yes"
                },
            }));
        } 
        else if (this.state.quickShiftFormData.serviceTypeId == ServiceType.Security) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    hardApproval: "No",
                    holdPayment: "No"
                },
            }));
        }        
    }
    // Handles the selection of multiplier value based on service type, provider, venue, and charging type.
    handleMultiplierValueSelection = () => {
        // Accrual comes from the service fee matrix whatever the charging type, so set it before the
        // charging-type branches below return early. Without this, a shift whose charging type is
        // already set (or an Entertainment shift with provider and venue) never derives Accrual.
        const serviceFeeMatrixDerivedValues = this.billableItemUtils.serviceFeeMatrixDerivation(
            this.state.quickShiftFormData.clientId,
            this.state.quickShiftFormData.serviceTypeId,
            this.state.quickShiftFormData.serviceSubTypeId
        );
        this.setState((prevState: Readonly<QuickAddShiftFormState>) => ({
            quickShiftFormData: {
                ...prevState.quickShiftFormData,
                isAccrual: serviceFeeMatrixDerivedValues.valueOfAccrual,
            },
        }));
        if (
            this.state.quickShiftFormData.serviceTypeId === ServiceType.Entertainment &&
            this.state.quickShiftFormData.providerId &&
            this.state.quickShiftFormData.venueId &&
            !this.state.quickShiftFormData.chargingTypeId
        ) {
            this.hasProviderBeenPreviouslySourceApiCall();
            return;
        }
        if (
            this.state.quickShiftFormData.chargingTypeId === ChargingType.NoFee ||
            this.state.quickShiftFormData.chargingTypeId === ChargingType.SourceIntroFee ||
            this.state.quickShiftFormData.chargingTypeId === ChargingType.ExistingActFee
        ) {
            this.deriveMultiplierForChargingType(this.state.quickShiftFormData.chargingTypeId);
            return;
        }
        let originator = serviceFeeMatrixDerivedValues.valueOfMultiplier;
        if (serviceFeeMatrixDerivedValues.originatorMultipliers.length > 0) {
            const originatorFiltered = serviceFeeMatrixDerivedValues.originatorMultipliers.filter(
                (item: { id: number; multiplier: string }) => item.id === this.state.quickShiftFormData.originator?.id
            );
            // Ensure we access the first item if filtering returned any results
            if (originatorFiltered.length > 0) {
                originator = originatorFiltered[0].multiplier;
            }
        }
        this.setState((prevState: Readonly<QuickAddShiftFormState>) => ({
            quickShiftFormData: {
                ...prevState.quickShiftFormData,
                fee_Percentage_Local_Ccy: this.sharedUtils.convertStringToFloat(originator),
            },
        }));
    };

    setQuantityAutomaticallyBasedOnService = () => {
        if (this.state.quickShiftFormData.serviceTypeId == ServiceType.Entertainment ||
            this.state.quickShiftFormData.serviceTypeId == ServiceType.Gardening ||
            this.state.quickShiftFormData.serviceTypeId == ServiceType.WindowCleaning ||
            this.state.quickShiftFormData.serviceTypeId == ServiceType.Maintenance ||
            this.state.quickShiftFormData.serviceTypeId == ServiceType.Miscelleanous ||
            (this.state.quickShiftFormData.serviceTypeId == ServiceType.ContractCleaning && this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.AdditionalCleaning)||
            (this.state.quickShiftFormData.serviceTypeId == ServiceType.ContractCleaning && this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.Laundry)) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    equipmentQuantity: 1,
                    equipmentScheduleQuantity: 1,
                    billable_Start: "",
                    billable_Finish: "",
                    shift_End: "",
                    shift_Start: ""
                },
            }),()=>{
                this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.quantity);
            });
        }
        else if(this.state.quickShiftFormData.serviceTypeId == ServiceType.ContractCleaning && this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.WeeklyCleaning){
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    equipmentScheduleQuantity: this.state.quickShiftFormData.equipmentQuantity,
                },
            }),()=>{
                this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.quantity);
            });
        } else if(this.state.quickShiftFormData.serviceTypeId == ServiceType.Security){
            this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.quantity);
        }
    }

    dateToChangeLogic = () => {
        if (
            this.lookupService.isSubTypeIdEqualToUnitOfMeasureType(
                this.state.quickShiftFormData.serviceSubTypeId,
                UnitOfMeasureTypes.time,
                this.state.unitOfMeasureList
            )
        ) {
            this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.time);
        } else if (
            this.lookupService.isSubTypeIdEqualToUnitOfMeasureType(
                this.state.quickShiftFormData.serviceSubTypeId,
                UnitOfMeasureTypes.quantity,
                this.state.unitOfMeasureList
            )
        ) {
            this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.quantity);
        } else if (
            this.state.quickShiftFormData.serviceTypeId == ServiceType.ContractCleaning ||
            this.state.quickShiftFormData.serviceTypeId == ServiceType.Entertainment
        ) {
            this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.quantity);
        }
    };


    disableFieldsBasedOnUnitOfMeasure = (unitOfMeasureType: string) => {
        let dateTo = this.addEditutils.setDateToField(
            unitOfMeasureType,
            this.state.quickShiftFormData.date,
            this.state.quickShiftFormData.serviceTypeId,
            this.state.quickShiftFormData.serviceSubTypeId
        );
        let isLockTimeFields = this.addEditutils.lockTimeFields(unitOfMeasureType);
        let isLockQuantityFields = this.addEditutils.lockQuantityFields(unitOfMeasureType);
        this.setState((prevState: any) => ({
            IsLockTimeFields: isLockTimeFields,
            IsLockQuantityFields: isLockQuantityFields,
            quickShiftFormData: {
                ...prevState.quickShiftFormData,
                dateTo: dateTo,
            },
        }));
    };

    handleChangeServiceSubTypeSelect = (dxValueChange: LookUpOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    serviceSubTypeId: dxValueChange.value,
                    chargingTypeId: "",
                },
                previouslySourced: false,
                existingAct: false,
                isRequestCalculationChange: true,
            }), () => {
                this.filterDataSourceForRole(this.state.typeLookUp, dxValueChange.value);
                this.setQuantityAutomaticallyBasedOnService();
                this.handleMultiplierValueSelection();
                this.selectHardApprovalHoldPaymentValue();
            });
        }
    }

    handleChangeClientTypeSelect = (dxValueChange: LookUpOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    clientId: dxValueChange.value,
                    venueId: resolveGuardedDependentId(
                        prevState.quickShiftFormData.venueId,
                        prevState.isClientSelected,
                        ""
                    ),
                    chargingTypeId: "",
                },
                previouslySourced: false,
                existingAct: false,
                isRequestCalculationChange: true,
                isClientSelected: true,
            }), () => {
                this.handleMultiplierValueSelection();
            });
        }
        this.setFeeTaxApplicableOnInitialLoad();
        this.setTaxApplicableStatus(dxValueChange.value);
    }

    handleChangeWorkDescription = (dxValueChange: TextBoxOnValueChangedEvent) => {
        this.setState((prevState: any) => ({
            quickShiftFormData: {
                ...prevState.quickShiftFormData,
                description: dxValueChange.value,
            },
        }));
    };

    handleChangeWorkOtherDescription = (dxValueChange: TextBoxOnValueChangedEvent) => {
        this.setState((prevState: any) => ({
            quickShiftFormData: {
                ...prevState.quickShiftFormData,
                otherDescription: dxValueChange.value,
            },
        }));
    };


    handleChangeOriginator = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    originator: {
                        id: dxValueChange.value,
                        value: ""
                    },
                    providerPayAmountLocal:"",
                    chargingTypeId: "",
                },
                previouslySourced: false,
                existingAct: false,
                isRequestCalculationChange: true,
            }), () => {
                this.handleMultiplierValueSelection();
            });
        }
    }

    handleChangeComments = (dxValueChange: TextBoxOnValueChangedEvent) => {
        this.setState((prevState: any) => ({
            quickShiftFormData: {
                ...prevState.quickShiftFormData,
                comments: dxValueChange.value,
            },
        }));
    };

    handleChangeInternalComments = (dxValueChange: TextBoxOnValueChangedEvent) => {
        this.setState((prevState: any) => ({
            quickShiftFormData: {
                ...prevState.quickShiftFormData,
                internalComments: dxValueChange.value,
            },
        }));
    };

    hideWarningPopup = () => {
        this.setState({
            showWarningPopup: false,
            showCalculatedPopup: false
        });
    };

    showCalculationPopup = () => {
        this.setState({showCalculatedPopup: true}); 
    }

    onSubmit = () => {
        this.setState({
            loadPanelVisible: true,
        });
        let recalculate = false;
        recalculate = this.state.isPopupProviderNetChange == true || this.state.isPopupEventNetChange == true ? true : false;
        let quickShiftSubmitRequest = this.utils.convertFormDataToQuickShiftRequest(this.state.quickShiftFormData, recalculate); 

        // for PBI-18685 start
        if(this.state.isPopupProviderNetChange == true) {                
            quickShiftSubmitRequest.providerNetOverride = quickShiftSubmitRequest.provider_Pay_Amount_Local_Ccy;
            
        }
        if(this.state.isPopupEventNetChange == true) {
            quickShiftSubmitRequest.feeAmountOverride = quickShiftSubmitRequest.fee_Amount_Local_Ccy;
            quickShiftSubmitRequest.providerNetOverride = quickShiftSubmitRequest.provider_Pay_Amount_Local_Ccy;
        }
        if(this.state.isPopupProviderNetChange == false) {   
            if(this.state.isPopupEventNetChange == true) quickShiftSubmitRequest.providerNetOverride = quickShiftSubmitRequest.provider_Pay_Amount_Local_Ccy;             
            else quickShiftSubmitRequest.providerNetOverride = "";                
        }
        if(this.state.isPopupEventNetChange == false) {
            quickShiftSubmitRequest.feeAmountOverride = "";
        }
        // for PBI-18685 end

        let billableItemSubmitRequestArr: QuickBillableItemSubmitRequest[] = [];
        billableItemSubmitRequestArr.push(quickShiftSubmitRequest);        
        //passing object data to the server
        this.service
            .uploadEditAddDataV3(billableItemSubmitRequestArr)
            .then((res)=>this.handleFormDataSubmissionSuccess(res))
            .catch((err)=>this.handleFormSubmissionFailure(err))
            .finally(() => {
                this.hideLoadpanel();
            });
    };    

    handleFormDataSubmissionSuccess = (response: AxiosResponse<any>) => { 
        this.hideLoadpanel();
        this.handleSuccessContinueDataSource(response); 
        this.setState({
            showCalculatedPopup: false,
            showWarningPopup: false,
            confirmationPanelVisible: true,
            errorPanelVisible: false
        });
        if(this.props.navigateFrom == "venueCalendar" && this.props.hideAndRefresh){
            this.props.hideAndRefresh();
        }
        else if(this.props.navigateFrom == "providerCalendar" && this.props.hideAndRefresh){
            this.props.hideAndRefresh();
        }
        else if(this.props.navigateFrom == "queryGrid"){
            this.props.hidePopup(false);
        }
        else if (this.props.location.state.pointOfNavigation && this.props.location.state.pointOfNavigation.toLowerCase() == "findanartistlandingpage") {
            this.props.history.goBack();
        }
        else{
            this.addEditutils.renderRedirectCommonMethod(this.props, true, "apply",'');
            // this.props.history.goBack();
            // this.props.history.push({
            //     pathname: "/simpleShifts",
            //     state: {
            //         pointOfNavigation: "popUp",
            //         startDate: this.props.location.state.filterStartDate,
            //         endDate: this.props.location.state.filterEndDate,
            //     },
            // });
        }
    };

    submitShift = () => {
        let errors = [];
        if(this.state.quickShiftFormData.serviceTypeId == ""){
            let error = {
                "columnName": "Service",
                "errorType": "Error",
                "errorMessage": "Service has not been provided. Please select service."
            };
            errors.push(error);
        }
        if(this.state.quickShiftFormData.serviceSubTypeId == ""){
            let error = {
                "columnName": "Sub Type",
                "errorType": "Error",
                "errorMessage": "Sub Type has not been provided. Please select sub type."
            };
            errors.push(error);
        }
        if(this.state.quickShiftFormData.clientId == ""){
            let error = {
                "columnName": "Client",
                "errorType": "Error",
                "errorMessage": "Client has not been provided. Please select client."
            };
            errors.push(error);
        }
        if(this.state.quickShiftFormData.serviceTypeId == ServiceType.ContractCleaning && this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.WeeklyCleaning && this.state.hours == undefined){
            let error = {
                "columnName": "Hours",
                "errorType": "Error",
                "errorMessage": "Please provide the Hours before submitting the Form"
            };
            errors.push(error);
        }
        if(this.state.quickShiftFormData.serviceTypeId == ServiceType.ContractCleaning && this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.WeeklyCleaning && this.state.minutes == ""){
            let error = {
                "columnName": "Minutes",
                "errorType": "Error",
                "errorMessage": "Minutes has not been provided. Please select minutes."
            };
            errors.push(error);
        }
        if(this.state.quickShiftFormData.serviceTypeId == serviceTypes.Entertainment && this.state.quickShiftFormData.shift_Start == undefined){
            let error = {
                "columnName": "Start Time",
                "errorType": "Error",
                "errorMessage": "Start Time has not been provided. Please select start time."
            };
            errors.push(error);
        }
        if(this.state.quickShiftFormData.serviceTypeId == serviceTypes.Entertainment && this.state.quickShiftFormData.shift_End == undefined){
            let error = {
                "columnName": "Finish Time",
                "errorType": "Error",
                "errorMessage": "Finish Time has not been provided. Please select finish time."
            };
            errors.push(error);
        }
        if(this.state.quickShiftFormData.serviceTypeId == ServiceType.Security && this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.DoorSupervisionPersonnel && this.state.quickShiftFormData.billable_Start == undefined){
            let error = {
                "columnName": "Finish Time",
                "errorType": "Error",
                "errorMessage": "Finish Time has not been provided. Please select finish time."
            };
            errors.push(error);
        }
        if(this.state.quickShiftFormData.serviceTypeId == ServiceType.Security && this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.DoorSupervisionPersonnel && this.state.quickShiftFormData.billable_Finish == undefined){
            let error = {
                "columnName": "Finish Time",
                "errorType": "Error",
                "errorMessage": "Finish Time has not been provided. Please select finish time."
            };
            errors.push(error);
        }  
        if(errors.length > 0){            
            this.setState({
                errorMessage: errors,
                errorPanelVisible: true,
                confirmationPanelVisible: false,
            });
        }     
        else{
            if(this.state.isRequestCalculationChange){
                this.hasProviderBeenPreviouslySourceApiCall(true)
            }
            else{
                let providerNet = this.state.quickShiftFormData.provider_Pay_Amount_Local_Ccy.toString() == "" || this.state.quickShiftFormData.provider_Pay_Amount_Local_Ccy.toString() == "0.00" || 
                    this.state.quickShiftFormData.provider_Pay_Amount_Local_Ccy.toString() == "£0.00" ? "0" : this.state.quickShiftFormData.provider_Pay_Amount_Local_Ccy;
                let feeNet = this.state.quickShiftFormData.fee_Amount_Local_Ccy.toString() == "" || this.state.quickShiftFormData.fee_Amount_Local_Ccy.toString() == "0.00" || 
                    this.state.quickShiftFormData.fee_Amount_Local_Ccy.toString() == "£0.00" ? "0" : this.state.quickShiftFormData.fee_Amount_Local_Ccy;
                let clientNet = this.state.quickShiftFormData.client_Billable_Amount_Local_Ccy.toString() == "" || this.state.quickShiftFormData.client_Billable_Amount_Local_Ccy.toString() == "0.00" || 
                    this.state.quickShiftFormData.client_Billable_Amount_Local_Ccy.toString() == "£0.00" ? "0" : this.state.quickShiftFormData.client_Billable_Amount_Local_Ccy;
                
                if(providerNet == "0" || feeNet == "0" || clientNet == "0"){
                        this.setState({showWarningPopup: true});                
                } 
                else{
                    this.setState({showCalculatedPopup: true}); 
                } 
            }
        }
    }
    hasProviderBeenPreviouslySourceApiCall = (fromSubmit: boolean = false) =>{
        if(this.state.quickShiftFormData.providerId){
            this.setState({
                loadPanelVisible: true,
            });
            // Fetch the Service Fee Matrix first so both the Previously Sourced and Existing Act checks
            // can be gated on the matrix's own allowed-flags (sourceIntroFeeAllowed / existingActAllowed)
            // rather than calling either API unconditionally.
            this.serviceFeeMatrixApiCall(fromSubmit);
        }
        else{
            this.setState({errorMessage:[ {
                "columnName": "Provider Id",
                "errorType": "Error",
                "errorMessage": "Provider Id has not been provided. Please select provider Id."
            }]})
        }
    }
    
    resolvePreviouslySourcedFlag = (responseData: any): boolean => {
        if (typeof responseData === "boolean") {
            return responseData;
        }
        if (responseData && typeof responseData === "object") {
            return responseData.previouslySourced === true || responseData?.data?.previouslySourced === true;
        }
        return false;
    }
    
    resolveExistingActFlag = (responseData: any): boolean => {
        if (typeof responseData === "boolean") {
            return responseData;
        }
        if (responseData && typeof responseData === "object") {
            return responseData.existingAct === true || responseData?.data?.existingAct === true;
        }
        return false;
    }
    
    checkExistingActApiCall = (serviceFeeMatrix: any, fromSubmit: boolean = false) => {
        const providerId = this.state.quickShiftFormData.providerId;
        const venueId = this.state.quickShiftFormData.venueId;
        const serviceTypeId = this.state.quickShiftFormData.serviceTypeId;
        const originatorId = this.state.quickShiftFormData.originator && this.state.quickShiftFormData.originator.id
            ? String(this.state.quickShiftFormData.originator.id)
            : "";
        const existingActAllowed = !!(serviceFeeMatrix.existingActAllowed ?? serviceFeeMatrix.existingActFeeAllowed);
        if (
            !providerId ||
            !venueId ||
            serviceTypeId !== ServiceType.Entertainment ||
            !existingActAllowed
        ) {
            this.setState({ existingAct: false }, () => {
                this.finalizeChargingType(serviceFeeMatrix, fromSubmit);
            });
            return;
        }
        this.service
            .getCheckExistingActByProviderId(providerId, venueId, originatorId, serviceTypeId)
            .then((response: AxiosResponse<any>) => {
                const existingActValue = this.resolveExistingActFlag(response.data);
                this.setState({ existingAct: existingActValue }, () => {
                    this.finalizeChargingType(serviceFeeMatrix, fromSubmit);
                });
            })
            .catch((err) => {
                this.setState({
                    errorMessage: err.response ? JSON.parse(JSON.stringify(err.response.data.error)) : null,
                    IsShowSuccess: false,
                    disabledApplybutton: true,
                    loadPanelVisible: false,
                });
                this.failureMessageVisible();
            });
    }

    checkPreviouslySourcedApiCall = (serviceFeeMatrix: any, fromSubmit: boolean = false) => {
        const providerId = this.state.quickShiftFormData.providerId;
        const venueId = this.state.quickShiftFormData.venueId;
        const sourceIntroAllowed = !!serviceFeeMatrix.sourceIntroFeeAllowed;
        if (!sourceIntroAllowed) {
            this.setState({ previouslySourced: false }, () => {
                this.checkExistingActApiCall(serviceFeeMatrix, fromSubmit);
            });
            return;
        }
        this.service.getPreviouslySourcedByProviderId(providerId, venueId)
            .then((response: AxiosResponse<any>) => {
                const previouslySourcedValue = this.resolvePreviouslySourcedFlag(response.data);
                this.setState({
                    previouslySourced: previouslySourcedValue
                },()=>{
                    this.checkExistingActApiCall(serviceFeeMatrix, fromSubmit)
                })
            })
            .catch((err) => {
                this.setState({
                    errorMessage: err.response ? JSON.parse(JSON.stringify(err.response.data.error)) : null, // For capturing response at the time of exception and showing error message
                    IsShowSuccess: false,
                    disabledApplybutton: true,
                });
                this.failureMessageVisible();
                this.setState({
                    loadPanelVisible: false,
                });
            })
    }
    serviceFeeMatrixApiCall=(fromSubmit: boolean = false)=>{
        this.setState({
            loadPanelVisible: true,
        });
        let clientId = this.state.quickShiftFormData.clientId
        let serviceTypeId = this.state.quickShiftFormData.serviceTypeId
        let serviceSubTypeId =this.state.quickShiftFormData.serviceSubTypeId
        const originatorId = this.state.quickShiftFormData.originator && this.state.quickShiftFormData.originator.id
            ? String(this.state.quickShiftFormData.originator.id)
            : "";
        this.serviceFeeService.getServiceFeeMatrixDataItemFilter(clientId,serviceTypeId,serviceSubTypeId,originatorId)
            .then((response: AxiosResponse<any>) => {
                const serviceFeeMatrix = response.data || {};
                this.checkPreviouslySourcedApiCall(serviceFeeMatrix, fromSubmit);
            })
            .catch((err) => {
                this.setState({
                    errorMessage: err.response ? JSON.parse(JSON.stringify(err.response.data.error)) : null, // For capturing response at the time of exception and showing error message
                    IsShowSuccess: false,
                    disabledApplybutton: true,
                });
                this.failureMessageVisible();
                this.setState({
                    loadPanelVisible: false,
                });
            })
    }
    finalizeChargingType = (serviceFeeMatrix: any, fromSubmit: boolean = false) =>{
        const sourceIntroAllowed = !!serviceFeeMatrix.sourceIntroFeeAllowed;
        const existingActAllowed = !!(serviceFeeMatrix.existingActAllowed ?? serviceFeeMatrix.existingActFeeAllowed);
        const applyExistingActFee = existingActAllowed && this.state.existingAct;
        const applySourceIntroFee = sourceIntroAllowed && this.state.previouslySourced && !applyExistingActFee;
        const nextChargingType = applyExistingActFee
            ? ChargingType.ExistingActFee
            : applySourceIntroFee
                ? ChargingType.SourceIntroFee
                : ChargingType.Regular;
        this.setState((prevState: any) => ({
            quickShiftFormData: {
                ...prevState.quickShiftFormData,
                chargingTypeId: nextChargingType,
            },
            loadPanelVisible: false,
        }), () => {
            this.deriveMultiplierForChargingType(nextChargingType, () => this.financialCalculations(fromSubmit));
        });

    }
    handleChangeChargingType = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    chargingTypeId: dxValueChange.value,
                },
            }), () => {
                this.deriveMultiplierForChargingType(dxValueChange.value, this.financialCalculations);
            });
        }
    };
    // A manual Charging Type change is a deliberate switch of fee basis, so it re-derives the Event
    // Multiplier itself rather than deferring to whatever the previously-sourced/source-intro check in
    // handleserviceFeeMatrixSuccess last put there (mirrors AddEditFormV2's handleChangeChargingType):
    // - No Fee: multiplier is always zero.
    // - Source Intro Fee: multiplier comes from the service fee matrix's source intro fee multiplier,
    //   regardless of the provider's previously-sourced status.
    // - Regular/anything else: the normal service fee matrix derivation (same as
    //   handleMultiplierValueSelection).
    // `onDone` runs from the setState callback below rather than being called right after this method
    // returns, since fee_Percentage_Local_Ccy is not committed to state synchronously and
    // financialCalculations reads it straight off this.state.quickShiftFormData.
    deriveMultiplierForChargingType = (chargingTypeId: string, onDone?: () => void) => {
        if (chargingTypeId === ChargingType.NoFee) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    fee_Percentage_Local_Ccy: 0,
                },
            }), onDone);
            return;
        }
        let serviceFeeMatrixDerivedValues = this.billableItemUtils.serviceFeeMatrixDerivation(
            this.state.quickShiftFormData.clientId,
            this.state.quickShiftFormData.serviceTypeId,
            this.state.quickShiftFormData.serviceSubTypeId
        );
        let multiplier: any = "";
        if (chargingTypeId === ChargingType.ExistingActFee) {
            multiplier = serviceFeeMatrixDerivedValues.valueOfExistingActFeeMultiplier;
        } else if (chargingTypeId === ChargingType.SourceIntroFee) {
            multiplier = serviceFeeMatrixDerivedValues.valueOfSourceIntroFeeMultiplier;
        } else {
            multiplier = serviceFeeMatrixDerivedValues.valueOfMultiplier;
            if (serviceFeeMatrixDerivedValues.originatorMultipliers.length > 0) {
                let originatorFiltered = serviceFeeMatrixDerivedValues.originatorMultipliers.filter(
                    (item: any) => item.id === this.state.quickShiftFormData.originator?.id
                );
                if (originatorFiltered.length > 0) {
                    multiplier = originatorFiltered[0].multiplier;
                }
            }
        }
        this.setState((prevState: any) => ({
            quickShiftFormData: {
                ...prevState.quickShiftFormData,
                fee_Percentage_Local_Ccy: this.sharedUtils.convertStringToFloat(multiplier),
            },
        }), onDone);
    };
    // fromSubmit: only the ADD/APPLY flow (submitShift -> finalizeChargingType) should open the
    // Zero Amounts warning / calculation popups; recalculations from field changes (provider,
    // venue, charging type etc.) must not.
    financialCalculations = (fromSubmit: boolean = false) => {
        this.setState({
            loadPanelVisible: true,
        });       
        let calCulationObject = this.addEditutils.convertQuickAddCalcDataToCalcRequest(
            this.state.quickShiftFormData,
            null,
            0,
            this.props.location && this.props.location.state ? this.props.location.state.id : this.props.billableItemId,
        );
        calCulationObject.previouslySourced = this.state.previouslySourced?this.state.previouslySourced:false,
        this.service
            .uploadFormData(calCulationObject)
            .then((response) => this.handleCalculationSuccess(response, fromSubmit))
            .catch((err) => {
                this.setState({
                    errorMessage: err.response ? JSON.parse(JSON.stringify(err.response.data.error)) : null, // For capturing response at the time of exception and showing error message
                    IsShowSuccess: false,
                    disabledApplybutton: true,
                });
                this.failureMessageVisible();
                this.setState({
                    loadPanelVisible: false,
                }); 
            })
            .finally(() => {
                this.setState({
                    loadPanelVisible: false,
                }); 
            });

    };

    handleCalculationSuccess = (response: AxiosResponse<any>, fromSubmit: boolean = false) => {
        let serverResponse: CalculationResponse = response.data.data;
        let providerNet = serverResponse.providerPayAmount.toString() == "" || serverResponse.providerPayAmount.toString() == "0.00" || 
            serverResponse.providerPayAmount.toString() == "£0.00" ? "0" : serverResponse.providerPayAmount;
        let feeNet = serverResponse.grossProfitAmountLocal.toString() == "" || serverResponse.grossProfitAmountLocal.toString() == "0.00" || 
            serverResponse.grossProfitAmountLocal.toString() == "£0.00" ? "0" : serverResponse.grossProfitAmountLocal;
        let clientNet = serverResponse.clientBillableAmountLocal.toString() == "" || serverResponse.clientBillableAmountLocal.toString() == "0.00" || 
            serverResponse.clientBillableAmountLocal.toString() == "£0.00" ? "0" : serverResponse.clientBillableAmountLocal;
        this.setState({
            errorPanelVisible: false,
            disabledApplybutton: false,
            loadPanelVisible: false,
            isRequestCalculationChange: false,
        });
        if(this.state.quickShiftFormData.updateOrCorrection == "false"){
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.quickShiftFormData,
                    scheduledMinutes: serverResponse.billableMinutes,
                }
            }))
        }
        if(fromSubmit){
            if(providerNet == "0" || feeNet == "0" || clientNet == "0"){
                    this.setState({showWarningPopup: true});
            }
            else{
                this.setState({showCalculatedPopup: true});
            }
        }
        // Convert server response to proper data types
        this.setState((prevState: any) => ({
            quickShiftFormData: {
                ...prevState.quickShiftFormData,
                billable_Minutes: this.sharedUtils.convertStringToFloat(serverResponse.billableMinutes),
                provider_Pay_Amount_Local_Ccy: this.sharedUtils.convertStringToFloat(serverResponse.providerPayAmount),
                provider_Pay_Tax_Local_Ccy: this.state.quickShiftFormData.provider_Tax_Applicable == "Yes" || this.state.quickShiftFormData.provider_Tax_Applicable == "True" ? this.sharedUtils.convertStringToFloat(serverResponse.providerPayTaxLocalCcy) : 0.00,
                provider_Pay_Total_Local_Ccy: this.sharedUtils.convertStringToFloat(serverResponse.providerPayTotalLocalCcy),
                provider_Pay_Currency_Local_Ccy: serverResponse.providerPayAmountLocalCurrency, // Ex: "GBP"
                client_Billable_Amount_Local_Ccy: this.sharedUtils.convertStringToFloat(
                    serverResponse.clientBillableAmountLocal
                ),
                client_Billable_Tax_Local_Ccy: this.state.quickShiftFormData.client_Tax_Applicable == "Yes" || this.state.quickShiftFormData.client_Tax_Applicable == "True" ? this.sharedUtils.convertStringToFloat(
                    serverResponse.clientBillableTaxLocalCcy
                ) : 0.00,
                client_Billable_Total_Local_Ccy: this.sharedUtils.convertStringToFloat(
                    serverResponse.clientBillableTotalLocalCcy
                ),
                client_Billable_Currency_Local_Ccy: serverResponse.clientBillableAmountLocalCurrency,
                fee_Amount_Local_Ccy: this.sharedUtils.convertStringToFloat(serverResponse.grossProfitAmountLocal),
                fee_Tax_Local_Ccy: this.state.quickShiftFormData.fee_Tax_Applicable == "Yes" || this.state.quickShiftFormData.fee_Tax_Applicable == "True" ? this.sharedUtils.convertStringToFloat(serverResponse.grossProfitTaxLocalCcy) : 0.00,
                fee_Total_Local_Ccy: this.sharedUtils.convertStringToFloat(serverResponse.grossProfitTotalLocalCcy),
                fee_Currency_Local_Ccy: serverResponse.grossProfitAmountLocalCurrency,
                equipmentBillableQuantity: this.sharedUtils.convertStringToFloat(serverResponse.billableQuantity),
                billableRate: this.sharedUtils.convertStringToFloat(serverResponse.billableRate),
                providerPayAmountLocal: this.sharedUtils.convertStringToFloat(serverResponse.providerPayAmountLocal),
                providerPayAmountLocalExtras: this.sharedUtils.convertStringToFloat(serverResponse.providerPayAmountLocalExtras),
                providerPayAmountLocalWOExtras: this.sharedUtils.convertStringToFloat(serverResponse.providerPayAmountLocalWOExtras),
                providerFasterPayFee: this.sharedUtils.convertStringToFloat(serverResponse.providerFasterPayFee),
                providerFasterPayOriginalAmount: this.sharedUtils.convertStringToFloat(serverResponse.providerFasterPayOriginalAmount),
                accrual: serverResponse.accrual
                    ? {
                        id: serverResponse.accrual.id,
                        accrualTypeId: serverResponse.accrual.accrualTypeId,
                        accrualStatusId: serverResponse.accrual.accrualStatusId,
                        accrualBillableItemId: serverResponse.accrual.accrualBillableItemId,
                        accrualInvoiceId: serverResponse.accrual.accrualInvoiceId,
                        providerPayAmountAccrual: serverResponse.accrual.providerPayAmountAccrual,
                        providerPayAmountTaxAccrual: this.state.quickShiftFormData.provider_Tax_Applicable == "Yes" || this.state.quickShiftFormData.provider_Tax_Applicable == "True" ? serverResponse.accrual.providerPayAmountTaxAccrual : 0.00,
                        providerPayAmountTotalAccrual: serverResponse.accrual.providerPayAmountTotalAccrual,
                        grossProfitAmountAccrual: serverResponse.accrual.grossProfitAmountAccrual,
                        grossProfitAmountTaxAccrual: this.state.quickShiftFormData.fee_Tax_Applicable == "Yes" || this.state.quickShiftFormData.fee_Tax_Applicable == "True" ? serverResponse.accrual.grossProfitAmountTaxAccrual : 0.00,
                        grossProfitAmountTotalAccrual: serverResponse.accrual.grossProfitAmountTotalAccrual,
                        clientBillableAmountAccrual: serverResponse.accrual.clientBillableAmountAccrual,
                        clientBillableAmountTaxAccrual: this.state.quickShiftFormData.client_Tax_Applicable == "Yes" || this.state.quickShiftFormData.client_Tax_Applicable == "True" ? serverResponse.accrual.clientBillableAmountTaxAccrual : 0.00,
                        clientBillableAmountTotalAccrual: serverResponse.accrual.clientBillableAmountTotalAccrual,
                        lastUpdatedOn: serverResponse.accrual.lastUpdatedOn,
                        lastUpdatedBy: serverResponse.accrual.lastUpdatedBy,
                    }
                    : null,
            },
            expectedFee: this.sharedUtils.convertStringToFloat(serverResponse.grossProfitAmountLocal),
        }));

        // if (this.props.location && this.props.location.state && this.props.location.state.isAdjust) {
        //     // below block is applicable for Adjustment
        //     if (
        //         this.state.isChangeBillableStart ||
        //         this.state.isChangeBillableFinish ||
        //         this.state.isChangeRate ||
        //         this.state.isChangeQuantity ||
        //         this.state.isChangeHour ||
        //         this.state.isChangeMinute ||
        //         this.state.editViewDataItem.noCharge
        //     ) {
        //         if (
        //             (this.state.acceptDate != null ||
        //                 this.state.acceptDate != undefined ||
        //                 this.state.editViewDataItem.paymentId != null ||
        //                 this.state.editViewDataItem.paymentId != undefined ||
        //                 this.state.approvalDate != null ||
        //                 this.state.approvalDate != undefined ||
        //                 this.state.editViewDataItem.invoiceId != null ||
        //                 this.state.editViewDataItem.invoiceId != undefined) &&
        //             (this.state.editViewDataItem.itemTypeId == this.state.itemTypeLookUp[1].id ||
        //                 this.state.editViewDataItem.itemTypeId == this.state.itemTypeLookUp[3].id ||
        //                 this.state.editViewDataItem.itemTypeId == this.state.itemTypeLookUp[4].id)
        //         ) {
        //             if (Math.sign(this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy) == 1) {
        //                 this.setState({
        //                     calculationMessageClassName: "check-red",
        //                 });
        //                 if (UserService.isUserInGroup(RoleGroupNames.VenueManager)) {
        //                     this.state.calculationMessage.push(
        //                         "The new cost" +
        //                         currencyTypeToSymbolMatrix[
        //                         this.state.editViewDataItem.provider_Pay_Currency_Local_Ccy
        //                         ] +
        //                         this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy.toFixed(2) +
        //                         " will be sent for processing after this has been created"
        //                     );
        //                 } else {
        //                     this.state.calculationMessage.push(
        //                         "An additional cost " +
        //                         currencyTypeToSymbolMatrix[
        //                         this.state.editViewDataItem.provider_Pay_Currency_Local_Ccy
        //                         ] +
        //                         this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy.toFixed(2) +
        //                         " will be shown on the Client's next available cost report (after approval)"
        //                     );
        //                 }
        //             } else if (Math.sign(this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy) == -1) {
        //                 this.setState({
        //                     calculationMessageClassName: "check-blue",
        //                 });
        //                 if (UserService.isUserInGroup(RoleGroupNames.ProviderScheduler)) {
        //                     this.state.calculationMessage.push(
        //                         "The new cost " +
        //                         currencyTypeToSymbolMatrix[
        //                         this.state.editViewDataItem.provider_Pay_Currency_Local_Ccy
        //                         ] +
        //                         this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy.toFixed(2) +
        //                         " will be sent for processing after this has been created"
        //                     );
        //                 } else {
        //                     this.state.calculationMessage.push(
        //                         "A credit of " +
        //                         currencyTypeToSymbolMatrix[
        //                         this.state.editViewDataItem.provider_Pay_Currency_Local_Ccy
        //                         ] +
        //                         this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy.toFixed(2) +
        //                         " will be shown on the Client's next available cost report (after approval)"
        //                     );
        //                 }
        //             } else if (Math.sign(this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy) == 0) {
        //                 this.state.calculationMessage.push("");
        //             }
        //         }
        //     }
        // }

        // this.providerPayTaxCalculation();
        // this.feeTaxCalculation();
        // this.clientTaxCalculation();
        // taking the latest amount from prevState (the server amounts above aren't committed to this.state yet) calculating the total amount field
        this.setState((prevState: any) => {
            let feeTax = prevState.quickShiftFormData.fee_Tax_Local_Ccy ? prevState.quickShiftFormData.fee_Tax_Local_Ccy : 0;
            let clientTax = prevState.quickShiftFormData.client_Billable_Tax_Local_Ccy ? prevState.quickShiftFormData.client_Billable_Tax_Local_Ccy : 0;
            return {
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    provider_Pay_Total_Local_Ccy:
                        prevState.quickShiftFormData.provider_Pay_Amount_Local_Ccy +
                        prevState.quickShiftFormData.provider_Pay_Tax_Local_Ccy,
                    fee_Total_Local_Ccy:
                        prevState.quickShiftFormData.fee_Amount_Local_Ccy + feeTax,
                    client_Billable_Total_Local_Ccy:
                        prevState.quickShiftFormData.client_Billable_Amount_Local_Ccy + clientTax,
                },
            };
        });
        const serverAccrual = serverResponse.accrual;
        if (this.state.quickShiftFormData.isAccrual && serverAccrual) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    accrual: {
                        ...prevState.quickShiftFormData.accrual,
                        providerPayAmountTotalAccrual:
                            serverAccrual.providerPayAmountAccrual +
                            serverAccrual.providerPayAmountTaxAccrual,
                        grossProfitAmountTotalAccrual:
                            serverAccrual.grossProfitAmountAccrual +
                            serverAccrual.grossProfitAmountTaxAccrual,
                        clientBillableAmountTotalAccrual:
                            serverAccrual.clientBillableAmountAccrual +
                            serverAccrual.clientBillableAmountTaxAccrual,
                    },
                },
            }));
        }
        // this.handleItemTypeSelection();
    };

    failureMessageVisible = () => {
        this.setState({
            errorPanelVisible: true,
        });
    }; 

    onContinue = () => {
        this.setState({
            confirmationPanelVisible: true,
            errorPanelVisible: false
        });
        if(this.props.navigateFrom == "queryGrid"){
            this.props.hidePopup(false);
        }
        else{
            this.props.history.goBack();
            this.props.history.push({
                pathname: "/simpleShifts",
                state: {
                    pointOfNavigation: "popUp",
                    startDate: this.props.location.state.filterStartDate,
                    endDate: this.props.location.state.filterEndDate,
                },
            });
        }
    }

    handleSuccessContinueDataSource = (response: AxiosResponse<any>) => {
        // Convert to proper data types
        let viewDataSource = this.utils.convertQuickShiftResponeToFormData(response.data.data[0]);
        this.setState({
            quickShiftFormData: viewDataSource,
            CleaningMinutesToDisplay: response.data.data[0].equipmentQuantity
        });
        this.offeringsTypeDataSource(viewDataSource.serviceTypeId);
        if (viewDataSource.serviceSubTypeId == SubServiceType.WeeklyCleaning) {
            let quantitySubFields: string[] = this.outStandingActionUtils.splitQuantityIntoHoursMinutesFormat(
                response.data.data[0].equipmentQuantity
            );
            this.setState({
                hours:
                    quantitySubFields.length > 0 && quantitySubFields[0]
                        ? this.sharedUtils.convertStringToInt(quantitySubFields[0])
                        : 0,
                minutes: quantitySubFields.length > 0 && quantitySubFields[1] ? quantitySubFields[1] : "00"
            });
        }
    }

    hideLoadpanel() {
        this.setState({ loadPanelVisible: false });
    }

    handleFormSubmissionFailure = (err: any) => {
        this.hideLoadpanel();
        this.setState({
            errorMessage:
                err.response && err.response.data && err.response.data.data.length > 0 && err.response.data.data[0].validationErrors
                    ? JSON.parse(JSON.stringify(err.response.data.data[0].validationErrors))
                    : null,
            errorPanelVisible: true,
            confirmationPanelVisible: false,
            showCalculatedPopup: false,
        });
        if(this.props.navigateFrom == "venueCalendar" && this.props.hideAndRefresh){
            this.props.hideAndRefresh();
        }
        else if(this.props.navigateFrom == "providerCalendar" && this.props.hideAndRefresh){
            this.props.hideAndRefresh();
        }
    };

    onContentReadyNumberBox = (e: any) => {
        this.onClickElementSelection(e);
    }

    handleChangeHours = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState({
                hours: dxValueChange.value,
                isRequestCalculationChange: true,
            });
            this.state.hourChangeTimer = setTimeout(this.reCalculateQuantity, 1000);
        }
    };

    handleChangeMinutes = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState({
                minutes: dxValueChange.value,
                isRequestCalculationChange: true,
            });
            this.state.hourChangeTimer = setTimeout(this.reCalculateQuantity, 1000);
        }
    };

    handleChangeTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    typeId: dxValueChange.value
                },
            }));
        }
    };

    handleChangeShiftStart = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    shift_Start: dxValueChange.value,
                },
                isRequestCalculationChange: true,
            }));
        }
    };

    handleChangeShiftEnd = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    shift_End: dxValueChange.value,
                },
                isRequestCalculationChange: true,
            }));
        }
    };

    handleChangeBillableStart = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            if (this.props.location.state?.id == 0) {
                this.setState((prevState: any) => ({
                    quickShiftFormData: {
                        ...prevState.quickShiftFormData,
                        billable_Start: dxValueChange.value,
                        shift_Start: dxValueChange.value,
                    },
                    isRequestCalculationChange: true,
                }));
            }
            else {
                this.setState((prevState: any) => ({
                    quickShiftFormData: {
                        ...prevState.quickShiftFormData,
                        billable_Start: dxValueChange.value,
                    },
                    isRequestCalculationChange: true,
                }));
            }
        }
    };

    handleChangeBillableEnd = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            if (this.props.location.state.id == 0) {
                this.setState((prevState: any) => ({
                    quickShiftFormData: {
                        ...prevState.quickShiftFormData,
                        billable_Finish: dxValueChange.value,
                        shift_End: dxValueChange.value,
                    },
                    isRequestCalculationChange: true,
                }));
            }
            else {
                this.setState((prevState: any) => ({
                    quickShiftFormData: {
                        ...prevState.quickShiftFormData,
                        billable_Finish: dxValueChange.value,
                    },
                    isRequestCalculationChange: true,
                }));
            }
        }
    };

    handleChangeName = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    name: dxValueChange.value
                },
            }));
        }
    };

    handleChangeRate = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    rate_Decimal: dxValueChange.value,
                    billableRate: dxValueChange.value,
                },
                isRequestCalculationChange: true,
            }));
            if (this.props.location.state.id == 0) {
                this.setState((prevState: any) => ({
                    quickShiftFormData: {
                        ...prevState.quickShiftFormData,
                        scheduleRate: dxValueChange.value,
                    },
                    isRequestCalculationChange: true,
                }));
            }
        }
    };

    handleChangeIdentificationNumber = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    identification_Number: dxValueChange.value
                },
            }));
        }
    };

    handleChangeAuthorisedBy = (dxValueChange: TextBoxOnValueChangedEvent) => {
        this.setState((prevState: any) => ({
            quickShiftFormData: {
                ...prevState.quickShiftFormData,
                requestApprover: dxValueChange.value
            },
        }));
    };

    handleChangeAdditionalInfo = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    additionalInformation: dxValueChange.value
                },
            }));
        }
    };

    handleChangeQuantity = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    equipmentQuantity: dxValueChange.value,
                },
                isRequestCalculationChange: true,
            }));
            if (this.props.location.state.id == 0) {
                this.setState((prevState: any) => ({
                    quickShiftFormData: {
                        ...prevState.quickShiftFormData,
                        equipmentScheduleQuantity: dxValueChange.value,
                    },
                    isRequestCalculationChange: true,
                }));
            }
        }
    };


    //Helper function to recalulate the Quantity when either of the minute or Hour field varies.
    reCalculateQuantity = () => {
        let delimeter = ".";
        let { hours, minutes } = this.state; //Destructure the state to pull out the contents.
        let convertedHours: string | undefined = (hours !== null && hours !== undefined)
        ? this.sharedUtils.convertNumberToString(hours)
        : undefined;
        let quantity: string = `${convertedHours}${delimeter}${minutes}`;
        this.setState((prevState: any) => ({
            quickShiftFormData: {
                ...prevState.quickShiftFormData,
                equipmentQuantity: this.sharedUtils.convertStringToFloat(quantity),
            },
        }));
        if (this.props.location.state.id == 0) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    equipmentScheduleQuantity: this.sharedUtils.convertStringToFloat(quantity),
                },
            }));
        }
    };

    onContentReadyDateBox = (e: any) => {
        this.onClickElementSelection(e);
    }

    onClickElementSelection = (e: any) => {
        e.element.addEventListener('click', function () {
            let inputElement = e.element.querySelector(".dx-texteditor-input");
            inputElement.selectionStart = 0;
            inputElement.selectionEnd = inputElement.value.length;
        });
    }

    handleChangeDate = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    date: dxValueChange.value,
                },
            }), () => {
                // Run after the new date has committed to state (dateToChangeLogic derives Date To from it)
                if (this.state.quickShiftFormData.serviceTypeId == ServiceType.Gardening ||
                    this.state.quickShiftFormData.serviceTypeId == ServiceType.WindowCleaning ||
                    this.state.quickShiftFormData.serviceTypeId == ServiceType.Maintenance ||
                    this.state.quickShiftFormData.serviceTypeId == ServiceType.Miscelleanous) {
                    this.setState((prevState: any) => ({
                        quickShiftFormData: {
                            ...prevState.quickShiftFormData,
                            dateTo: dxValueChange.value
                        }
                    }));
                }
                else {
                    this.dateToChangeLogic();
                }
            });
        }
    };

    handleChangeRequestedOn = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    requestDate: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeDateTo = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    dateTo: dxValueChange.value,
                },
            }));
        }
    };

    setTaxApplicableStatus = (businessEntityId: string) => {
        let taxStatus = this.state.businessEntityTaxApplicableStatuses.find(
            (item) => item.businessEntityID === businessEntityId
        );
        let taxApplicable: string = "No";

        // A client/provider is tax applicable if they have a tax registration number
        if (taxStatus && taxStatus.taxApplicable) {
            taxApplicable = "Yes";
        }

        if (taxStatus) {
            // Based on entity type, populate the tax applicable dropdown
            switch (taxStatus.businessEntityType) {
                case BusinessEntityTypes.Client:
                    this.setState((prevState: any) => ({
                        quickShiftFormData: {
                            ...prevState.quickShiftFormData,
                            client_Tax_Applicable: taxApplicable,
                        },
                    }));
                    break;
                case BusinessEntityTypes.Provider:
                    this.setState((prevState: any) => ({
                        quickShiftFormData: {
                            ...prevState.quickShiftFormData,
                            provider_Tax_Applicable: taxApplicable,
                        },
                    }));
                    break;
            }
        }
    };

    onCancel = () => {
        if(this.props.navigateFrom == "venueCalendar"){
            this.props.hidePopup(false);
        }
        else if(this.props.navigateFrom == "providerCalendar"){
            this.props.hidePopup(false);
        }
        else if(this.props.location.state?.pointOfNavigation == "ManageShifts"){
            // this.props.history.goBack();
            this.props.history.push({
                pathname: "/manageviewshift",
                state: {
                    pointOfNavigation: "popUp",
                    dateFrom: this.props.location.state.filterStartDate,
                    dateTo: this.props.location.state.filterEndDate,
                },
            });
        }   
        else if(this.props.navigateFrom == "queryGrid"){
            this.props.hidePopup(false);
        }
        else if (this.props.location.state?.pointOfNavigation && this.props.location.state.pointOfNavigation.toLowerCase() == "findanartistlandingpage") {
            this.props.history.goBack();
        }
        else{   
            this.addEditutils.renderRedirectCommonMethod(this.props, false, "cancel", ""); 
            // this.props.history.push({
            //     pathname: "/simpleShifts",
            //     state: {
            //         pointOfNavigation: "popUp",
            //         startDate: this.props.location.state.filterStartDate,
            //         endDate: this.props.location.state.filterEndDate,
            //     },
            // });
        }
    }

    handleChangeStatusTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    billableStatusLookupId: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeCorrectionUpdate = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    updateOrCorrection: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeProviderNet = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                    quickShiftFormData: {
                        ...prevState.quickShiftFormData,
                        provider_Pay_Amount_Local_Ccy: dxValueChange.value,
                        client_Billable_Amount_Local_Ccy: null,                        
                    },
                    isPopupProviderNetChange: true,
                }));
        }
    };
    handleChangeEventNet = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                    quickShiftFormData: {
                        ...prevState.quickShiftFormData,
                        fee_Amount_Local_Ccy: dxValueChange.value,
                        client_Billable_Amount_Local_Ccy: null,
                    },
                    isPopupEventNetChange: true,
                }));
        }
    };

    hidePopup = (isPopupVisible: boolean) => {
        this.props.hidePopup(isPopupVisible);
    }

    getCreatedAndUpdatedString = () => {
        let finalString = '';
        if(this.state.quickShiftFormData.dateCreated){
          let formattedDate = moment(this.state.quickShiftFormData.dateCreated).format("Do MMM YYYY HH:mm:ss");
          let createdBy = '';
          if(this.state.quickShiftFormData.createdBy){
            createdBy = this.state.quickShiftFormData.createdBy;
          }
          finalString = `Created On ${formattedDate} ${createdBy?`by ${createdBy}`:''}`;
        }
        if(this.state.quickShiftFormData.lastUpdatedOnTZ){
            if(finalString){
                finalString += ' / ';
            }
            let formattedDate = moment(this.state.quickShiftFormData.lastUpdatedOnTZ).format("Do MMM YYYY HH:mm:ss");
            let updatedBy = '';
            if(this.state.quickShiftFormData.lastUpdatedBy){
                updatedBy = this.state.quickShiftFormData.lastUpdatedBy;
            }
            finalString += `Last Updated On ${formattedDate} ${updatedBy?`by ${updatedBy}`:''}`;
          }
          if(finalString){
            finalString =` (${finalString})`;
          }
       return finalString;
    }

    getDateCreatedSection = () => {
        let show = false;
        if (UserService.isUserInGroup(RoleGroupNames.EventUKSeniorManager)) {
            show = true;
        }
        if (show) {
            return (
                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                    <div className="row">
                        <div className="mx-0 mt-3">
                            <label className="card-form__label text-left text-xl-right">
                                Date Created
                            </label>
                        </div>
                        <div className="col-12 col-xl mx-0 mt-3">
                            <DateBox
                            type='date'
                                useMaskBehavior={true}
                                displayFormat="dd/MM/yyyy"
                                onValueChanged={this.onHandleDateCreated}
                                value={
                                    this.state.quickShiftFormData.dateCreated_UI
                                        ? this.state.quickShiftFormData.dateCreated_UI
                                        : undefined
                                }
                                onContentReady={this.onContentReadyDateBox}
                            />
                        </div>
                        <div className="col-12 col-xl mx-0 mt-3">
                            <DateBox
                                type="time"
                                interval={15}
                                placeholder="00:00"
                                useMaskBehavior={true}
                                displayFormat={"HH:mm"}
                                onValueChanged={this.handleChangeDateCreatedTime}
                                value={
                                    this.state.quickShiftFormData.dateCreatedTime
                                        ? this.state.quickShiftFormData.dateCreatedTime
                                        : undefined
                                }
                                onContentReady={this.onContentReadyDateBox}
                            />
                        </div>
                    </div>
                </div>
            )
        }
        return;
    }

    onHandleDateCreated = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    dateCreated_UI: dxValueChange.value,
                },
            }));
        }
    }

    handleChangeDateCreatedTime = (dxValueChange: DateBoxOnValueChangedEvent)=>{
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                quickShiftFormData: {
                    ...prevState.quickShiftFormData,
                    dateCreatedTime: dxValueChange.value,
                },
            }));
        }
    }

    renderCommonPart = () => {
        let isShowFasterPayFee: boolean = true;
        let isShowProviderPay: boolean = true;
        let isShowType: boolean = true;
        if (this.state.quickShiftFormData.serviceTypeId == ServiceType.Security && (this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.DoorSupervisionPersonnel || this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.DoorSupervisionEquipment)) {
            isShowType = false;
        }
        if (this.state.quickShiftFormData.fasterPayment && this.state.quickShiftFormData.serviceTypeId == ServiceType.Entertainment) {
            isShowFasterPayFee = false;
        }
        if (this.state.quickShiftFormData.provider_Tax_Applicable == "True" || this.state.quickShiftFormData.provider_Tax_Applicable == "Yes") {
            isShowProviderPay = false;
        }
        let isShowRequestedOn: boolean = true;
        if (this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.AdditionalCleaning ||
            this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.Laundry ||
            this.state.quickShiftFormData.serviceTypeId == ServiceType.Gardening ||
            this.state.quickShiftFormData.serviceTypeId == ServiceType.WindowCleaning ||
            this.state.quickShiftFormData.serviceTypeId == ServiceType.Maintenance ||
            this.state.quickShiftFormData.serviceTypeId == ServiceType.Miscelleanous) {
            isShowRequestedOn = false;
        }
        let buttonName: string = "";
        if (this.props.location.state?.id || this.props.billableItemId) {
            buttonName = "Apply";
        }
        else {
            buttonName = "Add";
        }
        let isHide: boolean = false;
        let showOtherDesc: boolean = false;
        if ((this.state.quickShiftFormData.serviceTypeId == ServiceType.Security && (this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.DoorSupervisionPersonnel || this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.DoorSupervisionEquipment)) ||
            (this.state.quickShiftFormData.serviceTypeId == ServiceType.ContractCleaning && this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.WeeklyCleaning) ||
            this.state.quickShiftFormData.serviceTypeId == ServiceType.Entertainment) {
            isHide = true;
        }
        if ((this.state.quickShiftFormData.serviceTypeId == ServiceType.ContractCleaning && this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.AdditionalCleaning && this.state.quickShiftFormData.typeId == "227") || 
            (this.state.quickShiftFormData.serviceTypeId == ServiceType.Entertainment && this.state.quickShiftFormData.serviceSubTypeId == "50") || 
            (this.state.quickShiftFormData.serviceTypeId == ServiceType.WindowCleaning && this.state.quickShiftFormData.serviceSubTypeId == "108" && this.state.quickShiftFormData.typeId == "516") || 
            (this.state.quickShiftFormData.serviceTypeId == ServiceType.Gardening && this.state.quickShiftFormData.serviceSubTypeId == "106" && this.state.quickShiftFormData.typeId == "405") || 
            (this.state.quickShiftFormData.serviceTypeId == ServiceType.Maintenance || this.state.quickShiftFormData.serviceTypeId == ServiceType.Miscelleanous)) {
                showOtherDesc = true;
        }
        let hideHeader = false;
        if(this.props.navigateFrom == "queryGrid") hideHeader = true;
        if(this.props.navigateFrom == "venueCalendar") hideHeader = true;
        if(this.props.navigateFrom == "providerCalendar") hideHeader = true;

        let showHeaderForCalendar = false
        if(this.props.navigateFrom == "venueCalendar") showHeaderForCalendar = true;
        if(this.props.navigateFrom == "providerCalendar") showHeaderForCalendar = true;
        return (
            <div id="additionalCleaningForm" className={this.props.navigateFrom== "queryGrid" ? "page-content--without-sidebar-hidden-mobile" : "page-content--with-sidebar-hidden-mobile"}>
                <div className="col-12">
                    <h3 className="card-form__page-heading" hidden={hideHeader}>Quick - Add Shift</h3>
                    <h3 className="card-form__page-heading" hidden={!showHeaderForCalendar}>Quick -  Add / Edit Shift</h3>
                    <form data-testid="addEditPayment-form" className="card card-form my-5">
                        <div className="card-body">
                            <section>
                                <div className="card-form__field card-form__field--wide">
                                    Status
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                    <DropDownFromLookupTable
                                        lookupTypeIndex={LookupTypeIndexes.statusType}
                                        onValueChanged={this.handleChangeStatusTypeSelect}
                                        value={this.state.quickShiftFormData.billableStatusLookupId} 
                                        disableSignal={true}/>
                                    <input
                                        data-testid={LookupTypeIndexes.statusType}
                                        type="hidden"
                                        name={LookupTypeIndexes.statusType}
                                        value={
                                            this.state.quickShiftFormData.billableStatusLookupId
                                                ? this.state.quickShiftFormData.billableStatusLookupId
                                                : 0
                                        }
                                    ></input>
                                </div>
                                <div className="card-form__field card-form__field--wide">
                                    Service
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                    <DropDownFromLookupTableDynamic
                                        lookupTypeIndex={LookupTypeIndexes.serviceType}
                                        isRoot={true}
                                        parentMappingId={"0"}
                                        onValueChanged={this.handleChangeServiceTypeSelect}
                                        isDisabled={this.state.quickShiftFormData.paymentId?true:false}
                                        value={this.state.quickShiftFormData.serviceTypeId}
                                    />
                                    <input
                                        data-testid={LookupTypeIndexes.serviceType}
                                        type="hidden"
                                        name={LookupTypeIndexes.serviceType}
                                        value={
                                            this.state.quickShiftFormData.serviceTypeId
                                                ? this.state.quickShiftFormData.serviceTypeId
                                                : ""
                                        }
                                    ></input>
                                </div>
                                <div className="card-form__field card-form__field--wide">
                                    Sub Type
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                    <LookupTypeListDynamic
                                        lookupTypeIndex={LookupTypeIndexes.subServiceType}
                                        isRoot={false}
                                        parentMappingId={this.state.quickShiftFormData.serviceTypeId}
                                        displayExpression={"value"}
                                        onValueChanged={this.handleChangeServiceSubTypeSelect}
                                        value={this.state.quickShiftFormData.serviceSubTypeId}
                                        isDisabled={this.state.quickShiftFormData.paymentId?true:false}
                                    />
                                </div>
                                <div className="card-form__field card-form__field--wide" hidden={isShowType}>
                                    Type
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                        <DropDownFromLookupTableDynamic
                                            lookupTypeIndex={LookupTypeIndexes.offeringsType}
                                            isRoot={false}
                                            parentMappingId={this.state.quickShiftFormData.serviceSubTypeId}
                                            onValueChanged={this.handleChangeTypeSelect}
                                            isDisabled={this.state.quickShiftFormData.paymentId?true:false}
                                            value={this.state.quickShiftFormData.typeId}
                                        />
                                        <input
                                            data-testid={LookupTypeIndexes.offeringsType}
                                            type="hidden"
                                            name={LookupTypeIndexes.offeringsType}
                                            value={
                                                this.state.quickShiftFormData.typeId
                                                    ? this.state.quickShiftFormData.typeId
                                                    : ""
                                            }
                                        ></input>
                                </div>
                                {this.renderServiceWiseType()}
                                <div className="card-form__field card-form__field--wide"  hidden={!showOtherDesc}>
                                    Description
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                    <TextBox
                                        onValueChanged={this.handleChangeWorkOtherDescription}
                                        value={this.state.quickShiftFormData.otherDescription}
                                        maxLength={25}
                                        disabled={this.state.quickShiftFormData.paymentId?true:false}
                                    ></TextBox>
                                </div>
                                <div className="card-form__field card-form__field--wide"  hidden={showOtherDesc}>
                                    Description
                                    <sup className="card-form__mandatory-symbol" hidden= {this.state.quickShiftFormData.serviceTypeId == ServiceType.Entertainment || this.state.quickShiftFormData.serviceTypeId == ServiceType.ContractCleaning || 
                                                this.state.quickShiftFormData.serviceTypeId == ServiceType.WindowCleaning || this.state.quickShiftFormData.serviceTypeId == ServiceType.Gardening ||
                                                this.state.quickShiftFormData.serviceTypeId == ServiceType.Security}>*</sup>
                                    <TextBox
                                        onValueChanged={this.handleChangeWorkDescription}
                                        value={this.state.quickShiftFormData.description}
                                        maxLength={25}
                                        disabled={this.state.quickShiftFormData.paymentId?true:false}
                                    ></TextBox>
                                </div>
                                <div className="card-form__field card-form__field--wide">
                                    Client
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                    <LookupTypeListDynamic
                                        lookupTypeIndex={LookupTypeIndexes.clientType}
                                        onValueChanged={this.handleChangeClientTypeSelect}
                                        isRoot={false}
                                        parentMappingId={""}
                                        displayExpression={"value"}
                                        value={this.state.quickShiftFormData.clientId}
                                        recordType={this.props.location.state?.id ? "all" : "active"}
                                        isDisabled={this.state.quickShiftFormData.paymentId||this.state.quickShiftFormData.bill_Date?true:false}
                                    />
                                </div>
                                <div className="card-form__field card-form__field--wide">
                                    {this.props.t("additionalCleaning.raiseForm.venue.label")}
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                    <LookupTypeListDynamic
                                        lookupTypeIndex={LookupTypeIndexes.venueType}
                                        onValueChanged={this.handleChangeVenueTypeSelect}
                                        isRoot={true}
                                        parentMappingId={this.state.quickShiftFormData.clientId}
                                        value={this.state.quickShiftFormData.venueId}
                                        displayExpression={"value"}
                                        recordType={this.props.location.state?.id ? "all" : "active"}
                                        isDisabled={this.state.quickShiftFormData.paymentId||this.state.quickShiftFormData.bill_Date?true:false}
                                    />
                                </div>

                                <div className="card-form__field card-form__field--wide">
                                    Provider
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                    <LookupTypeListDynamic
                                        lookupTypeIndex={LookupTypeIndexes.providerType}
                                        onValueChanged={this.handleChangeProviderTypeSelect}
                                        isRoot={false}
                                        parentMappingId={""}
                                        displayExpression={"value"}
                                        value={this.state.quickShiftFormData.providerId}
                                        recordType={this.props.location.state?.id ? "all" : "active"}
                                        isDisabled={this.state.quickShiftFormData.paymentId?true:false}
                                    />
                                </div>
                                {this.state.quickShiftFormData.serviceTypeId=="30" && <div className="card-form__field card-form__field--wide">
                                    Profile
                                    <SelectBox
                                        dataSource={this.state.profileLookup}
                                        displayExpr={"value"}
                                        valueExpr={"id"}
                                        onValueChanged={this.handleChangeProfileSelect}
                                        value={
                                                this.state.quickShiftFormData.providerBusinessEntityProfileId
                                                ? this.state.quickShiftFormData.providerBusinessEntityProfileId
                                                : ""
                                        }
                                    />
                                </div> }                                    
                                {this.renderServiceWisePart()}   
                                
                                <div hidden={isHide}>
                                    {/* <div className="card-form__field card-form__field--very-narrow" style={{ marginRight: '20px' }}>
                                        Work Date(s)
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                        <DateBox
                                            onValueChanged={this.handleChangeDate}
                                            value={
                                                this.state.quickShiftFormData.date
                                                    ? this.state.quickShiftFormData.date
                                                    : undefined
                                            }
                                            useMaskBehavior={true}
                                            displayFormat="dd/MM/yyyy"
                                        ></DateBox>
                                    </div>
                                    <div className="card-form__field card-form__field--very-narrow">
                                        Date To
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                        <DateBox
                                            onValueChanged={this.handleChangeDateTo}
                                            value={
                                                this.state.quickShiftFormData.dateTo
                                                    ? this.state.quickShiftFormData.dateTo
                                                    : undefined
                                            }
                                            useMaskBehavior={true}
                                            displayFormat="dd/MM/yyyy"
                                            onContentReady={this.onContentReadyDateBox}
                                        ></DateBox>
                                    </div> */}

                                    {this.commonDateSection()} 
                                </div>                         
                               <div style={{ display: 'flex' }}>
                                <div className="card-form__field card-form__field--very-narrow" hidden={isHide} style={{ marginRight: '20px' }}>
                                    {this.props.t("additionalCleaning.raiseForm.agreedCost.label")}
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                    <NumberBox
                                        format={{ type: "currency", precision: 2, currency: "GBP" }}
                                        onValueChanged={this.handleChangeRate}
                                        valueChangeEvent="keyup"
                                        value={this.state.quickShiftFormData.rate_Decimal}
                                        onContentReady={this.onContentReadyNumberBox}
                                        disabled={this.state.quickShiftFormData.paymentId?true:false}
                                    />
                                </div>
                                <div className="card-form__field card-form__field--very-narrow" hidden={this.state.quickShiftFormData.serviceSubTypeId !== SubServiceType.Laundry}>
                                    Quantity
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                    <NumberBox
                                        onValueChanged={this.handleChangeQuantity}
                                        valueChangeEvent="keyup"
                                        value={
                                            this.state.quickShiftFormData.equipmentQuantity
                                        }
                                        onContentReady={this.onContentReadyNumberBox}
                                        step={0}
                                        disabled={this.state.quickShiftFormData.paymentId?true:false}
                                    />
                                </div>
                                </div>
                                <div className="card-form__field card-form__field--very-narrow" hidden={isShowFasterPayFee}>
                                    Faster Pay Fee
                                    <NumberBox
                                        disabled={this.state.quickShiftFormData.paymentId?true:false||true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onContentReady={this.onContentReadyNumberBox}
                                        value={this.state.quickShiftFormData.providerFasterPayFee}
                                    />
                                </div>
                                <div className="card-form__field card-form__field--very-narrow" hidden={isShowFasterPayFee}>
                                    Adjusted Artist Fee
                                    <NumberBox
                                        disabled={this.state.quickShiftFormData.paymentId?true:false||true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onContentReady={this.onContentReadyNumberBox}
                                        value={this.state.quickShiftFormData.providerPayAmountLocal}
                                    />
                                </div>
                                <div className="card-form__field card-form__field--very-narrow" hidden={isShowProviderPay}>
                                    Provider NET
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={this.state.quickShiftFormData.provider_Pay_Amount_Local_Ccy}
                                        placeholder={"Calculation Pending...."}
                                        disabled={this.state.quickShiftFormData.paymentId?true:false||true}
                                    />
                                </div>
                                <div className="card-form__field card-form__field--very-narrow" hidden={isShowProviderPay}>
                                    Provider VAT
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={this.state.quickShiftFormData.provider_Pay_Tax_Local_Ccy}
                                        placeholder={"Calculation Pending...."}
                                        disabled={this.state.quickShiftFormData.paymentId?true:false||true}
                                    />
                                </div>
                                <div className="card-form__field card-form__field--very-narrow" hidden={isShowProviderPay}>
                                    Provider GROSS
                                    <NumberBox
                                        disabled={this.state.quickShiftFormData.paymentId?true:false||true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onContentReady={this.onContentReadyNumberBox}
                                        value={this.state.quickShiftFormData.provider_Pay_Total_Local_Ccy}
                                        placeholder={"Calculation Pending...."}
                                    />
                                </div>
                                <div className="card-form__field card-form__field--wide" hidden={isHide}>
                                    {this.props.t("additionalCleaning.raiseForm.authorisedBy.label")}
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                    <TextBox
                                        onValueChanged={this.handleChangeAuthorisedBy}
                                        value={this.state.quickShiftFormData.requestApprover}
                                        disabled={this.state.quickShiftFormData.paymentId?true:false}
                                    ></TextBox>
                                </div>
                                <div className="card-form__field card-form__field--very-narrow" hidden={isShowRequestedOn}>
                                    Requested On
                                    <DateBox
                                        onValueChanged={this.handleChangeRequestedOn}
                                        value={
                                            this.state.quickShiftFormData.requestDate
                                                ? this.state.quickShiftFormData.requestDate
                                                : undefined
                                        }
                                        useMaskBehavior={true}
                                        displayFormat="dd/MM/yyyy"
                                        disabled={this.state.quickShiftFormData.paymentId?true:false}
                                    ></DateBox>
                                </div>
                                <div className="card-form__field card-form__field--wide">
                                    Originator
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                    <DropDownFromLookupTable
                                        lookupTypeIndex={LookupTypeIndexes.originator}
                                        onValueChanged={this.handleChangeOriginator}
                                        value={this.state.quickShiftFormData.originator && this.state.quickShiftFormData.originator.id ? this.state.quickShiftFormData.originator.id.toString() : "50"}
                                        recordType="active"
                                        disableSignal={this.state.quickShiftFormData.paymentId?true:false}
                                    />
                                    <input
                                        data-testid={LookupTypeIndexes.originator}
                                        type="hidden"
                                        name={LookupTypeIndexes.originator}
                                        value={this.state.quickShiftFormData.originator &&
                                            this.state.quickShiftFormData.originator.id
                                            ? this.state.quickShiftFormData.originator.id
                                            : 50
                                        }
                                    ></input>
                                </div>
                                <div className="card-form__field card-form__field--wide">
                                    Update (original input was incorrect) vs. Correction (real external change)
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                    <SelectBox
                                        dataSource={this.updateCorrectionDataSource}
                                        displayExpr="value"
                                        valueExpr="id"
                                        onValueChanged={this.handleChangeCorrectionUpdate}
                                        value={
                                            this.state.quickShiftFormData.updateOrCorrection
                                        }
                                        disabled={this.state.quickShiftFormData.paymentId?true:false}
                                    />
                                </div>
                                <div className="card-form__field card-form__field--wide">
                                    Charging Type
                                    <DropDownFromLookupTableDynamic
                                        lookupTypeIndex={LookupTypeIndexes.BillableItemChargingType}
                                        isRoot={true}
                                        parentMappingId={"0"}
                                        onValueChanged={this.handleChangeChargingType}
                                        value={this.state.quickShiftFormData.chargingTypeId}
                                    />
                                </div>

                                <div className="card-form__field card-form__field--wide">
                                    Internal Comments
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                    <TextArea
                                        height={100}
                                        value={this.state.quickShiftFormData.internalComments}
                                        onValueChanged={this.handleChangeInternalComments}
                                    />
                                </div>
                                <div className="card-form__field card-form__field--wide">
                                    External Comments
                                    <TextArea
                                        height={100}
                                        value={this.state.quickShiftFormData.comments}
                                        onValueChanged={this.handleChangeComments}
                                    />
                                </div>
                                {this.state.confirmationPanelVisible ? (
                                    <p className="card-form__confirmation">
                                        Your request has been submitted
                                    </p>
                                ) : (
                                    ""
                                )}
                                {this.state.errorPanelVisible ? (
                                    <ul className="card-form__errors">
                                        {this.state.errorMessage.map((item: any, uniqueKey: number) => {
                                            return (
                                                <li>
                                                    {item.columnName}: {item.errorMessage}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                ) : ("")}

                                <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={this.state.loadPanelVisible} />
                            </section>
                            <section className="card-form__button-container">
                                {this.state.quickShiftFormData.billableItemId !== "0" ?
                                    // <b> <div className="mx-4 mt-3">ID : {this.state.quickShiftFormData.billableItemId} {this.getCreatedAndUpdatedString()}</div> </b> 
                                    <>
                            <div className="row">
                                <div className="col-12 col-lg row mx-0 pr-0 mt-3">
                                    <b> <div className="mx-4 mt-3">ID : {this.state.quickShiftFormData.billableItemId} {this.getCreatedAndUpdatedString()}</div> </b>
                                </div>
                                {false && this.getDateCreatedSection()}
                            </div>

                        </> 
                                    : null}
                            </section>
                            <section className="card-form__button-container">
                                <div className="col-12 col-lg-4 col-xl-2">
                                    <button
                                        className="btn btn-primary btn--large mt-3"
                                        type="submit"
                                        onClick={(e: MouseEvent) => {
                                            e.preventDefault();
                                            this.submitShift()
                                        }}
                                    >
                                        {buttonName}
                                    </button>
                                </div>
                                <div className="col-12 col-lg-4 col-xl-2">
                                    <button
                                        className="btn btn--ghost btn--ghost--teal btn--large mt-3"
                                        onClick={(e: MouseEvent) => {
                                            e.preventDefault();
                                            this.onCancel();
                                        }}
                                    >
                                        Close
                                    </button>
                                </div>
                            </section>
                        </div>
                    </form>
                </div>
                <Popup
                    visible={this.state.showCalculatedPopup}
                    onHiding={this.hideWarningPopup}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showTitle={true}
                    showCloseButton={true}
                    title={"CONFIRM: Amounts Re-Calculated"}
                    resizeEnabled={true}
                    width={"55%"}
                    height={450}                        
                >
                    <ScrollView width='100%' height='100%'>
                        <div>
                            <div className="text-center card-form__subheading"><b>Amounts have been re-calculated as below - edit any changes required and click CONFIRM</b></div>
                        </div>                    
                        <div className="card-form__field card-form__field--narrow">
                            <h4 className="card-form__subheading">
                                Provider NET
                            </h4>
                            <NumberBox
                                format={{
                                    type: "currency",
                                    precision: 2,
                                    currency: "GBP",
                                }}
                                onValueChanged={this.handleChangeProviderNet}
                                valueChangeEvent="keyup"
                                value={this.state.quickShiftFormData.provider_Pay_Amount_Local_Ccy}
                                min={0}
                                max={9999.99}
                                step={0}
                                onContentReady={this.onContentReadyNumberBox}
                            />
                        </div>
                        <div className="card-form__field card-form__field--narrow">
                            <h4 className="card-form__subheading">
                                Event NET
                            </h4>
                            <div className="row px-3 event-net-width">
                                <div className="col-12 col-xl-5 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeEventNet}
                                        valueChangeEvent="keyup"
                                        value={this.state.quickShiftFormData.fee_Amount_Local_Ccy}
                                        min={0}
                                        max={9999.99}
                                        step={0}
                                        onContentReady={this.onContentReadyNumberBox}
                                    /> 
                                </div>
                                <div className="col-12 col-xl-7 pl-0 matching-error mt-0" hidden={!this.state.isPopupProviderNetChange}>
                                    <b>Provider NET has changed so the fee will be re-calculated afterwards unless over-typed</b>
                                </div>
                            </div>
                        </div>
                        <div className="card-form__field card-form__field--narrow">
                            <h4 className="card-form__subheading">
                                Client NET
                            </h4>
                            <NumberBox
                                format={{
                                    type: "currency",
                                    precision: 2,
                                    currency: "GBP",
                                }}
                                valueChangeEvent="keyup"
                                value={this.state.quickShiftFormData.client_Billable_Amount_Local_Ccy}
                                min={0}
                                max={9999.99}
                                step={0}
                                readOnly={true}
                                placeholder={"Calculation Pending...."}
                                onContentReady={this.onContentReadyNumberBox}
                            />
                        </div>

                        <div className="row px-3">
                            <div className="col-12 col-xl-3 pl-0">
                                <button
                                    className="btn btn-primary btn--large mt-3"
                                    type="submit"
                                    onClick={(e: MouseEvent) => {
                                        e.preventDefault();
                                        this.onSubmit();
                                    }}
                                >
                                    CONFIRM
                                </button>
                            </div>
                            <div className="col-12 col-xl-3 pl-0">
                                <button
                                    className="btn btn--ghost btn--ghost--teal btn--large mt-3"
                                    onClick={(e: MouseEvent) => {
                                        e.preventDefault();
                                        this.hideWarningPopup();
                                    }}
                                >
                                    CLOSE
                                </button>
                            </div>
                        </div> 
                    </ScrollView>
                </Popup>
                <Popup
                    visible={this.state.showWarningPopup}
                    onHiding={this.hideWarningPopup}
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    showTitle={true}
                    showCloseButton={true}
                    title={"WARNING: ZERO AMOUNTS"}
                    resizeEnabled={true}
                    width={"30%"}
                    height={300}                        
                >
                    <ScrollView width='100%' height='100%'>
                        <div>
                            <div className="text-center">Zero Amounts are present - please continue if expected otherwise please correct?</div>
                            <div className="text-center pt-3"><b>Provider Net</b> is {this.state.quickShiftFormData.provider_Pay_Amount_Local_Ccy == 0 ? <b className="color-red">£0.00</b> : <b>{this.state.quickShiftFormData.provider_Pay_Amount_Local_Ccy}</b>}</div>
                            <div className="text-center pt-3"><b>Fee Net</b> is {this.state.quickShiftFormData.fee_Amount_Local_Ccy == 0 ? <b className="color-red">£0.00</b> : <b>{this.state.quickShiftFormData.fee_Amount_Local_Ccy}</b>}</div>
                            <div className="text-center pt-3"><b>Client Net</b> is {this.state.quickShiftFormData.client_Billable_Amount_Local_Ccy == 0 ? <b className="color-red">£0.00</b> : <b>{this.state.quickShiftFormData.client_Billable_Amount_Local_Ccy}</b>}</div>
                        </div>
                        <div className="row px-3">
                                <div className="col-12 col-xl-6 pl-0">
                                    <button
                                        className="btn btn-primary btn--large mt-3"
                                        type="submit"
                                        onClick={(e: MouseEvent) => {
                                            e.preventDefault();
                                            this.showCalculationPopup()
                                        }}
                                    >
                                        CONTINUE?
                                    </button>
                                </div>
                                <div className="col-12 col-xl-6 pl-0">
                                    <button
                                        className="btn btn--ghost btn--ghost--teal btn--large mt-3"
                                        onClick={(e: MouseEvent) => {
                                            e.preventDefault();
                                            this.hideWarningPopup();
                                        }}
                                    >
                                        CLOSE
                                    </button>
                                </div>
                            </div> 
                    </ScrollView>
                </Popup>
            </div>
        )
    }

    commonDateSection = () =>{
        return (
            <div style={{ display: 'flex' }}>
                <div className="card-form__field card-form__field--very-narrow" style={{ marginRight: '20px' }}>
                    Work Date(s)
                    <sup className="card-form__mandatory-symbol">*</sup>
                    <DateBox
                        onValueChanged={this.handleChangeDate}
                        value={
                            this.state.quickShiftFormData.date
                                ? this.state.quickShiftFormData.date
                                : undefined
                        }
                        useMaskBehavior={true}
                        displayFormat="dd/MM/yyyy"
                        disabled={this.state.quickShiftFormData.paymentId?true:false}
                    ></DateBox>
                </div>
                <div className="card-form__field card-form__field--very-narrow">
                    Date To
                    <sup className="card-form__mandatory-symbol">*</sup>
                    <DateBox
                        onValueChanged={this.handleChangeDateTo}
                        value={
                            this.state.quickShiftFormData.dateTo
                                ? this.state.quickShiftFormData.dateTo
                                : undefined
                        }
                        useMaskBehavior={true}
                        displayFormat="dd/MM/yyyy"
                        onContentReady={this.onContentReadyDateBox}
                        disabled={this.state.quickShiftFormData.paymentId?true:false}
                    ></DateBox>
                </div>
            </div>
        )
    }

    renderServiceWisePart = () => {
        if (this.state.quickShiftFormData.serviceTypeId == ServiceType.Security && this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.DoorSupervisionPersonnel) {
            return (
                <>
                    <div className="card-form__field card-form__field--wide">
                        Date
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <div className="col-12 col-xl-6 pl-0">
                            <DateBox
                                onValueChanged={this.handleChangeDate}
                                value={
                                    this.state.quickShiftFormData.date
                                        ? this.state.quickShiftFormData.date
                                        : undefined
                                }
                                useMaskBehavior={true}
                                displayFormat="dd/MM/yyyy"
                                disabled={this.state.quickShiftFormData.paymentId?true:false}
                            ></DateBox>
                        </div>
                    </div>
                    {/* {this.commonDateSection()}  */}
                    <div className="card-form__field card-form__field--wide">
                        Start Time
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <div className="col-12 col-xl-6 pl-0">
                            <DateBox
                                type="time"
                                interval={15}
                                placeholder="00:00"
                                useMaskBehavior={true}
                                displayFormat={"HH:mm"}
                                onValueChanged={this.handleChangeBillableStart}
                                value={
                                    this.state.quickShiftFormData.billable_Start
                                        ? this.state.quickShiftFormData.billable_Start
                                        : undefined
                                }
                                onContentReady={this.onContentReadyDateBox}
                                disabled={this.state.quickShiftFormData.paymentId?true:false}
                            />
                        </div>
                    </div>
                    <div className="card-form__field card-form__field--wide">
                        Finish Time
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <div className="col-12 col-xl-6 pl-0">
                            <DateBox
                                type="time"
                                interval={15}
                                placeholder="00:00"
                                useMaskBehavior={true}
                                displayFormat={"HH:mm"}
                                onValueChanged={this.handleChangeBillableEnd}
                                value={
                                    this.state.quickShiftFormData.billable_Finish
                                        ? this.state.quickShiftFormData.billable_Finish
                                        : undefined
                                }
                                onContentReady={this.onContentReadyDateBox}
                                disabled={this.state.quickShiftFormData.paymentId?true:false}
                            />
                        </div>
                    </div>
                    <div className="card-form__field card-form__field--wide">
                        Rate
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <NumberBox
                            format={{
                                type: "currency",
                                precision: 2,
                                currency: "GBP",
                            }}
                            onValueChanged={this.handleChangeRate}
                            valueChangeEvent="keyup"
                            value={
                                this.state.quickShiftFormData.rate_Decimal
                            }
                            onContentReady={this.onContentReadyNumberBox}
                            step={0}
                            disabled={this.state.quickShiftFormData.paymentId?true:false}
                        />
                    </div>
                    <div className="card-form__field card-form__field--wide">
                        Name
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <TextBox
                            onValueChanged={this.handleChangeName}
                            value={
                                this.state.quickShiftFormData.name
                            }
                            disabled={this.state.quickShiftFormData.paymentId?true:false}
                        ></TextBox>
                    </div>
                    <div className="card-form__field card-form__field--wide">
                        Licence No.
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <TextBox
                            mask="0000-0000-0000-0000"
                            onValueChanged={this.handleChangeIdentificationNumber}
                            value={

                                this.state.quickShiftFormData.identification_Number
                            }
                            disabled={this.state.quickShiftFormData.paymentId?true:false}
                        ></TextBox>
                    </div>
                </>
            )
        }
        else if (this.state.quickShiftFormData.serviceTypeId == ServiceType.Security && this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.DoorSupervisionEquipment) {
            return (
                <>

                    {/* <div className="card-form__field card-form__field--wide">
                        Date From
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <div className="col-12 col-xl-6 pl-0">
                            <DateBox
                                onValueChanged={this.handleChangeDate}
                                value={
                                    this.state.quickShiftFormData.date
                                        ? this.state.quickShiftFormData.date
                                        : undefined
                                }
                                useMaskBehavior={true}
                                displayFormat="dd/MM/yyyy"
                            ></DateBox>
                        </div>
                    </div>
                    <div className="card-form__field card-form__field--wide">
                        Date To
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <div className="col-12 col-xl-6 pl-0">
                            <DateBox
                                onValueChanged={this.handleChangeDateTo}
                                value={
                                    this.state.quickShiftFormData.dateTo
                                        ? this.state.quickShiftFormData.dateTo
                                        : undefined
                                }
                                useMaskBehavior={true}
                                displayFormat="dd/MM/yyyy"
                                onContentReady={this.onContentReadyDateBox}
                            ></DateBox>
                        </div>
                    </div> */}
                    {this.commonDateSection()} 
                    <div className="card-form__field card-form__field--wide">
                        Quantity
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <NumberBox

                            onValueChanged={this.handleChangeQuantity}
                            valueChangeEvent="keyup"
                            value={

                                this.state.quickShiftFormData.equipmentQuantity
                            }
                            onContentReady={this.onContentReadyNumberBox}
                            step={0}
                            disabled={this.state.quickShiftFormData.paymentId?true:false}
                        />
                    </div>
                    <div className="card-form__field card-form__field--wide">
                        Rate
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <NumberBox
                            format={{
                                type: "currency",
                                precision: 2,
                                currency: "GBP",
                            }}
                            onValueChanged={this.handleChangeRate}
                            valueChangeEvent="keyup"
                            value={
                                this.state.quickShiftFormData.rate_Decimal
                            }
                            onContentReady={this.onContentReadyNumberBox}
                            step={0}
                            disabled={this.state.quickShiftFormData.paymentId?true:false}
                        />
                    </div>
                </>
            )
        }
        else if (this.state.quickShiftFormData.serviceTypeId == ServiceType.ContractCleaning && this.state.quickShiftFormData.serviceSubTypeId == SubServiceType.WeeklyCleaning) {
            return (
                <>
                    {/* <div className="card-form__field card-form__field--wide">
                        Date From
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <div className="col-12 col-xl-6 pl-0">
                            <DateBox
                                onValueChanged={this.handleChangeDate}
                                value={
                                    this.state.quickShiftFormData.date
                                        ? this.state.quickShiftFormData.date
                                        : undefined
                                }
                                useMaskBehavior={true}
                                displayFormat="dd/MM/yyyy"
                            ></DateBox>
                        </div>
                    </div>
                    <div className="card-form__field card-form__field--wide">
                        Date To
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <div className="col-12 col-xl-6 pl-0">
                            <DateBox
                                onValueChanged={this.handleChangeDateTo}
                                value={
                                    this.state.quickShiftFormData.dateTo
                                        ? this.state.quickShiftFormData.dateTo
                                        : undefined
                                }
                                useMaskBehavior={true}
                                displayFormat="dd/MM/yyyy"
                                onContentReady={this.onContentReadyDateBox}
                            ></DateBox>
                        </div>
                    </div> */}
                    {this.commonDateSection()} 
                    <div className="card-form__field card-form__field--wide">
                        Hours
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <NumberBox
                            onValueChanged={this.handleChangeHours}
                            valueChangeEvent="keyup"
                            value={this.state.hours}
                            onContentReady={this.onContentReadyNumberBox}
                            step={0}
                            disabled={this.state.quickShiftFormData.paymentId?true:false}
                        />
                    </div>
                    <div className="card-form__field card-form__field--wide">
                        Min
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <SelectBox
                            dataSource={minuteLookup}
                            displayExpr="value"
                            valueExpr="id"
                            onValueChanged={this.handleChangeMinutes}
                            value={
                                this.state.minutes
                            }
                            disabled={this.state.quickShiftFormData.paymentId?true:false}
                        />
                    </div>
                    <div className="card-form__field card-form__field--wide">
                        Rate
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <NumberBox
                            format={{
                                type: "currency",
                                precision: 2,
                                currency: "GBP",
                            }}
                            onValueChanged={this.handleChangeRate}
                            valueChangeEvent="keyup"
                            value={
                                this.state.quickShiftFormData.rate_Decimal
                            }
                            onContentReady={this.onContentReadyNumberBox}
                            step={0}
                            disabled={this.state.quickShiftFormData.paymentId?true:false}
                        />
                    </div>
                </>
            )
        }
        else if (this.state.quickShiftFormData.serviceTypeId == serviceTypes.Entertainment) {            
            return (
                <>
                    <div className="card-form__field card-form__field--wide">
                        Date
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <div className="col-12 col-xl-6 pl-0">
                            <DateBox
                                onValueChanged={this.handleChangeDate}
                                value={
                                    this.state.quickShiftFormData.date
                                        ? this.state.quickShiftFormData.date
                                        : undefined
                                }
                                useMaskBehavior={true}
                                displayFormat="dd/MM/yyyy"
                                disabled={this.state.quickShiftFormData.paymentId?true:false}
                            ></DateBox>
                        </div>
                    </div>
                    <div className="card-form__field card-form__field--wide">
                        Start Time
                        <div className="col-12 col-xl-6 pl-0">
                            <DateBox
                                type="time"
                                interval={15}
                                placeholder="00:00"
                                useMaskBehavior={true}
                                displayFormat={"HH:mm"}
                                onValueChanged={this.handleChangeShiftStart}
                                value={
                                    this.state.quickShiftFormData.shift_Start
                                        ? this.state.quickShiftFormData.shift_Start
                                        : undefined
                                }
                                onContentReady={this.onContentReadyDateBox}
                                disabled={this.state.quickShiftFormData.paymentId?true:false}
                            />
                        </div>
                    </div>
                    <div className="card-form__field card-form__field--wide">
                        Finish Time
                        <div className="col-12 col-xl-6 pl-0">
                            <DateBox
                                type="time"
                                interval={15}
                                placeholder="00:00"
                                useMaskBehavior={true}
                                displayFormat={"HH:mm"}
                                onValueChanged={this.handleChangeShiftEnd}
                                value={
                                    this.state.quickShiftFormData.shift_End
                                        ? this.state.quickShiftFormData.shift_End
                                        : undefined
                                }
                                onContentReady={this.onContentReadyDateBox}
                                disabled={this.state.quickShiftFormData.paymentId?true:false}
                            />
                        </div>
                    </div>
                    <div className="card-form__field card-form__field--wide">
                        Rate
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <NumberBox
                            format={{
                                type: "currency",
                                precision: 2,
                                currency: "GBP",
                            }}
                            onValueChanged={this.handleChangeRate}
                            valueChangeEvent="keyup"
                            value={
                                this.state.quickShiftFormData.rate_Decimal
                            }
                            onContentReady={this.onContentReadyNumberBox}
                            step={0}
                            disabled={this.state.quickShiftFormData.paymentId?true:false}
                        />
                    </div>
                    <div className="card-form__field card-form__field--wide">
                        Additional Information
                        <sup className="card-form__mandatory-symbol">*</sup>
                        <TextBox
                            onValueChanged={this.handleChangeAdditionalInfo}
                            value={
                                this.state.quickShiftFormData.additionalInformation
                            }
                            disabled={this.state.quickShiftFormData.paymentId?true:false}
                        ></TextBox>
                    </div>
                </>
            )
        }
    }

    renderServiceWiseType = () => {
        let isDisableOfferingsType: boolean = true;
        if (this.state.quickShiftFormData.paymentId===""||(this.state.offeringsTypeLookup && this.state.offeringsTypeLookup.length > 0) && this.state.quickShiftFormData.serviceSubTypeId) {
            isDisableOfferingsType = false;
        }
        if (this.state.quickShiftFormData.serviceTypeId == ServiceType.ContractCleaning || this.state.quickShiftFormData.serviceTypeId == serviceTypes.WindowCleaning || this.state.quickShiftFormData.serviceTypeId == serviceTypes.Gardening) {
            return (
                <div className="card-form__field card-form__field--wide">
                    Type
                    <SelectBox
                        dataSource={this.state.offeringsTypeLookup}
                        displayExpr={"value"}
                        valueExpr={"id"}
                        onValueChanged={this.handleChangeTypeSelect}
                        value={this.state.quickShiftFormData.typeId}
                        disabled={isDisableOfferingsType}
                    />
                </div>
            )
        }
        else if (this.state.quickShiftFormData.serviceTypeId == serviceTypes.Entertainment) {            
            return (
                <>
                    <div className="card-form__field card-form__field--wide">
                        Type
                        <sup className="card-form__mandatory-symbol" hidden={isDisableOfferingsType}>*</sup>
                        <SelectBox
                            dataSource={this.state.offeringsTypeLookup}
                            displayExpr={"value"}
                            valueExpr={"id"}
                            onValueChanged={this.handleChangeTypeSelect}
                            value={this.state.quickShiftFormData.typeId}
                            disabled={isDisableOfferingsType}
                        />
                    </div>
                </>
            )
        }
    }

    //#region render Component
    render() {
        let showSideBar = true
        if(this.props.navigateFrom == "queryGrid"){
            showSideBar = false
        }
        if(this.props.navigateFrom == "venueCalendar"){
            showSideBar = false
        }
        if(this.props.navigateFrom == "providerCalendar"){
            showSideBar = false
        }
        return (
            <LightModePageTemplate>
                { showSideBar ? 
                    <SideBarTemplate isFixedDesktopOnly={true}>
                        <BulletinPanel />
                    </SideBarTemplate>
                    : null
                }                
                { this.state.quickShiftFormData.itemTypeId != "10" && this.props.navigateFrom == "queryGrid" ? 
                    <AddEditFormV2 location={this.props.location} history={this.props.history} billableItemId={this.props.billableItemId ? this.props.billableItemId : "0"} hidePopup={this.hidePopup}></AddEditFormV2>
                    : this.renderCommonPart() 
                }
            </LightModePageTemplate>
        );
    }
}

export default withTranslation()(QuickAddShiftForm);
